export type Locale = "en" | "zh";

export type TranslationParams = Record<string, string | number>;

export const localeStorageKey = "attenda.locale";

const zhMessages: Record<string, string> = {
  "Language": "语言",
  "Switch to English": "切换到英文",
  "Switch to Chinese": "切换到中文",
  "English": "English",
  "Chinese": "中文",
  "Te reo Māori": "毛利语",
  "Simplified Chinese": "简体中文",
  "Attenda": "Attenda",
  "Attenda home": "Attenda 首页",
  "Attenda is an AI receptionist platform for New Zealand and Australian service businesses that need calls answered, appointments booked, and customers followed up.": "Attenda 帮助新西兰和澳大利亚服务型商家接听电话、预约客户并完成跟进。",

  "Technology": "能力",
  "Solutions": "方案",
  "Enterprise": "企业",
  "Rollout": "上线",
  "How it works": "如何运作",
  "Use cases": "适用场景",
  "Trust": "信任保障",
  "Launch plan": "上线计划",
  "Contact": "联系",
  "Book Demo": "预约演示",
  "Book setup call": "预约设置沟通",
  "Get Started": "开始使用",
  "Start setup": "开始设置",
  "Attenda Voice Intelligence": "Attenda 智能语音接待",
  "AI receptionist for service teams": "服务团队的智能电话接待",
  "Answer every call with": "让每一通电话都被妥善接起。",
  "intelligent voice AI.": "智能语音接待",
  "Answer every call with intelligent voice AI.": "让每一通电话都被智能接待妥善接起。",
  "Never miss a booking call again.": "不再错过预约电话。",
  "Attenda gives service teams a 24/7 phone receptionist that understands what callers need, captures details, books the next step, and leaves the team with clear follow-up.": "Attenda 为服务团队提供全天候电话接待，理解来电需求，记录关键信息，安排下一步，并给团队留下清晰的后续跟进。",
  "Attenda answers calls when your team is busy, captures what each caller needs, books the next step, and sends clear follow-up notes to staff.": "团队忙碌时，Attenda 帮你接听电话，记录客户需求，安排下一步，并把清晰跟进记录发送给团队。",
  "Start with your real phone workflow": "从真实电话流程开始",
  "Human step-in for urgent callers": "紧急来电可人工接手",
  "Follow-up notes after every call": "每通电话后都有跟进记录",
  "See the workflow": "查看流程",
  "Attenda AI voice assistant": "Attenda 智能语音接待",
  "Attenda listening during a live call": "Attenda 正在接听真实来电",
  "Attenda after-hours coverage": "Attenda 下班后接听",
  "Attenda captured the right details": "Attenda 已记录关键信息",
  "Attenda workflow integration": "Attenda 工作流程衔接",
  "Response": "响应",
  "Every missed call": "每通未接来电",
  "Clear follow-up notes": "清晰跟进记录",
  "Capabilities": "核心能力",
  "Built for live call operations.": "为真实电话业务打造。",
  "Answer, book, and follow up without changing your front desk.": "无需改变前台工作方式，也能接听、预约和跟进。",
  "The agent keeps conversations natural, captures useful context, and gives staff the control they expect from a modern CRM workflow.": "接待员保持自然对话，记录有用背景，并让团队像使用现代客户系统一样掌控后续动作。",
  "Callers get a calm receptionist. Your team gets the caller details, booking intent, and next action in one place.": "客户听到稳定的接待员；团队在一个地方看到来电详情、预约意向和下一步动作。",
  "Natural conversational flow": "自然对话流程",
  "Handles interruptions, clarifies intent, and asks one useful question at a time.": "能处理中断，确认来意，并一次只问一个有用问题。",
  "Always available": "随时在线",
  "Answers after hours, during rushes, and when the desk is already busy.": "下班后、高峰期、前台忙碌时都能接听。",
  "Clean capture": "记录清楚",
  "Caller details, urgency, preferences, and next steps are ready for review.": "来电人信息、紧急程度、偏好和下一步都能直接查看。",
  "Follow-up ready": "后续跟进清楚",
  "Turn call summaries into leads, bookings, alerts, and team work without making staff read through the whole call.": "把通话摘要整理成线索、预约、提醒和团队任务，团队无需重新读完整通话。",
  "Enterprise rollout": "企业上线",
  "Trust before launch": "上线前确认",
  "Governance for multi-site call operations.": "多门店电话运营的统一标准。",
  "Know what happens before the first live call.": "第一通真实来电前，先确认每一步。",
  "Give regional teams one operating standard for voice, bookings, and follow-up while each location keeps its own business details.": "让区域团队拥有统一的电话、预约和跟进标准，同时每个门店保留自己的业务细节。",
  "Attenda keeps caller-facing details, team alerts, step-in rules, and booking windows visible before you rely on the receptionist.": "在正式依赖接待员前，Attenda 会让客户可见信息、团队提醒、人工接手规则和可预约时间都清楚可见。",
  "Shared call standards": "统一接听标准",
  "Consistent call handling across locations": "不同门店保持一致接待体验",
  "Operational controls": "运营控制",
  "Published receptionist flows and answer governance": "已发布的接待流程和答案管理",
  "Connected records": "客户记录衔接",
  "Lead and booking updates ready for customer records": "线索和预约更新可进入客户记录",
  "Need rollout planning for a distributed team? We can map operating flows, launch checks, and ownership boundaries for each site.": "需要为多地点团队规划上线？我们可以帮你梳理每个地点的运营流程、上线检查和负责人边界。",
  "Caller experience": "客户体验",
  "Greeting, questions, and urgent call rules are reviewed before launch": "上线前先检查问候语、提问方式和紧急来电规则",
  "Team confidence": "团队放心",
  "Staff alerts and follow-up notes are checked before real callers depend on them": "真实客户依赖前，先检查团队提醒和跟进记录",
  "Launch checklist": "上线检查",
  "Phone number, booking hours, answers, and team contact stay in one setup path": "电话号码、预约时间、答案和团队联系人都在同一条设置路径中",
  "Need help before going live? Book a setup call and we will walk through the first caller journey with you.": "上线前需要帮助？预约一次设置沟通，我们会和你一起走完整个首通来电流程。",
  "Talk to rollout team": "联系上线团队",
  "(c) 2026 Attenda AI. Voice operations for service teams.": "(c) 2026 Attenda AI. 为服务团队管理电话运营。",

  "Account access is not ready yet.": "账号访问暂时还未准备好。",
  "Google sign-in is not ready yet.": "Google 登录暂时还未准备好。",
  "Google sign-in failed. Try again.": "Google 登录失败，请重试。",
  "Email sign-in is not ready yet.": "邮箱登录暂时还未准备好。",
  "Email sign-in failed. Check the email and password.": "邮箱登录失败，请检查邮箱和密码。",
  "We could not finish starting your session. Refresh the page and try again.": "暂时无法完成登录，请刷新页面后重试。",
  "Sign in to Attenda": "登录 Attenda",
  "Create your Attenda account": "创建 Attenda 账号",
  "Continue to Attenda": "继续使用 Attenda",
  "Manage calls, numbers, bookings, and customer follow-up for your business.": "为你的业务管理电话、号码、预约和客户跟进。",
  "Start or continue setup for calls, bookings, and customer follow-up.": "开始或继续设置电话、预约和客户跟进。",
  "Use Google to sign in or create your account.": "使用 Google 登录或创建账号。",
  "Use your Google Account": "使用 Google 账号登录",
  "Account access": "账号访问",
  "Account recovery": "账号恢复",
  "Account help": "账号帮助",
  "Help": "帮助",
  "Privacy": "隐私权",
  "Terms": "条款",
  "Email": "邮箱",
  "Email address": "邮箱地址",
  "Password": "密码",
  "Opening Google": "正在打开 Google",
  "Continue with Google": "使用 Google 继续",
  "Create account": "创建账号",
  "Continue": "继续",
  "Signing in": "正在登录",
  "Forgot password?": "忘记密码？",
  "Use Google to access your Attenda dashboard.": "使用 Google 进入你的 Attenda 工作台。",
  "New accounts use Google and continue into business setup after sign-in.": "新账号使用 Google 登录，登录后会继续进入业务设置。",
  "Already have an account? We will sign you in. New to Attenda? We will create your account and continue setup.": "已有账号会直接登录；没有账号会自动创建，并继续进入设置。",
  "Sign in with email instead": "改用邮箱登录",
  "Hide email sign-in": "收起邮箱登录",
  "Email sign-in": "邮箱登录",
  "For existing email users only. New accounts should continue with Google.": "仅适用于已有邮箱账号。新账号请使用 Google 继续。",
  "First business": "第一个业务",
  "Create the business callers will reach": "创建客户会拨打的业务",
  "After this, setup will guide the number, receptionist, answers, and team alerts in order.": "接下来，设置流程会按顺序引导电话号码、接待员、答案和团队提醒。",
  "Signed in as": "当前登录",
  "Sign-in required": "需要先登录",
  "Starting point": "起始类型",
  "Service business": "服务型业务",
  "Finish call setup": "完成接听设置",
  "Owner account": "负责人账号",
  "Set up your first business": "设置你的第一个业务",
  "Start with the business details customers recognise. You can refine the receptionist behavior during setup.": "先填写客户熟悉的业务信息。接下来可以继续调整接待员的行为。",
  "Harbour Dental Studio": "Harbour Dental Studio",
  "Business type": "业务类型",
  "Choose the closest starting point. Setup will adapt the details next.": "选择最接近的起始类型。后续设置会继续调整细节。",
  "Selected": "已选择",
  "Creating business": "正在创建业务",
  "Create business": "创建业务",
  "Sign in to create a business": "登录后创建业务",
  "Enter the business name before continuing.": "请先填写业务名称。",
  "Sign in before creating a business.": "请先登录再创建业务。",
  "Could not create this business. Try again.": "暂时无法创建这个业务，请重试。",
  "Hours": "时间",
  "When can callers book?": "客户什么时候可以预约？",
  "Who can step in during calls?": "谁可以在通话中接手？",
  "Needs hours": "需要设置时间",
  "Needs transfer phone": "需要转接电话",
  "Callers can be offered times inside saved booking windows.": "接待员可以在已保存的可预约时段内提供时间。",
  "Add the hours callers can book before the receptionist confirms times.": "请先添加客户可预约的时间，再让接待员确认预约。",
  "Time is available": "有可预约时间",
  "Urgent or sensitive calls have a person the receptionist can call.": "紧急或敏感电话已有接待员可联系的人。",
  "Add a transfer phone for calls that need a person.": "为需要人工接手的电话添加转接号码。",
  "Person can step in": "有人可以接手",
  "Booking hours are saved.": "可预约时间已保存。",
  "Save the days and times callers can book.": "保存客户可以预约的日期和时间。",
  "A team transfer phone is saved.": "团队转接电话已保存。",
  "Add a person the receptionist can call when a caller needs help.": "添加一个客户需要人工帮助时接待员可以联系的人。",
  "Save the normal booking windows the receptionist can use before offering appointment times.": "保存常规可预约时段，接待员会在这些时间内提供预约。",
  "Add the person or front desk phone the receptionist should use for urgent transfers.": "添加接待员处理紧急转接时应联系的人或前台电话。",
  "Choose at least one day callers can book.": "请至少选择一天可供客户预约。",
  "Choose a valid start and end time.": "请选择有效的开始和结束时间。",
  "Days callers can book": "客户可预约的日期",
  "Start time": "开始时间",
  "End time": "结束时间",
  "{count} booking windows are saved.": "已保存 {count} 个可预约时段。",
  "These hours keep suggested bookings inside the times your team can handle.": "这些时间会确保建议预约落在团队可处理的时段内。",
  "Transfer contact": "转接联系人",
  "Transfer phone": "转接电话",
  "Urgent calls can transfer to {name}.": "紧急电话可以转接给 {name}。",
  "Use a phone number the receptionist can call when a caller needs a person.": "填写接待员在客户需要真人时可以拨打的号码。",
  "Save booking hours": "保存可预约时间",
  "Save team contact": "保存团队联系人",
  "Call plan": "接听计划",
  "Confirm how callers reach you": "确认客户如何联系你",
  "Shape the calls Attenda can handle": "设置 Attenda 可以处理的来电",
  "Who should hear from Attenda?": "谁需要收到 Attenda 的通知？",
  "Business details and caller number are saved.": "业务信息和客户拨打号码已保存。",
  "Save the basics and connect the number customers will call.": "保存基础信息，并连接客户会拨打的号码。",
  "Call plan is published.": "接听计划已发布。",
  "Save services, booking hours, and receptionist behavior together.": "一起保存服务、可预约时间和接待方式。",
  "Team coverage and alerts are saved.": "团队接手和提醒已保存。",
  "Add who can step in and who should receive call alerts.": "添加谁可以接手，以及谁应接收来电提醒。",
  "Keep the caller-facing business details and phone number in one place so the first real call reaches the right setup.": "把客户会听到的业务信息和电话号码放在一起，确保第一通真实来电进入正确设置。",
  "Turn the caller story into services, booking windows, and the receptionist instructions callers will experience.": "把来电描述转成服务、可预约时间，以及客户实际听到的接待指令。",
  "Choose the people who can step in during calls and receive the next-step notes afterward.": "选择可在通话中接手并在之后接收下一步记录的人。",
  "Connect or buy a caller-facing number before continuing.": "继续前请连接或购买一个客户会拨打的号码。",
  "Add the people who should receive call alerts.": "添加应接收来电提醒的人。",
  "We could not draft this yet. Add a few notes or continue manually.": "暂时无法生成草稿。请添加几条备注，或继续手动填写。",
  "Writing draft": "正在生成草稿",
  "Help me write this": "帮我写这段",
  "Draft added. Review and adjust anything that does not sound like your business.": "草稿已加入。请检查并调整不符合你业务语气的内容。",
  "A short note is enough. We will turn it into services, questions, and step-in rules.": "写几句备注就够了。我们会把它转成服务、问题和人工接手规则。",
  "Save business basics": "保存业务基础信息",
  "Save call plan": "保存接听计划",
  "Save team coverage": "保存团队覆盖",
  "Services callers ask about": "客户会询问的服务",
  "Pick the requests Attenda should understand first.": "先选择 Attenda 需要理解的常见请求。",
  "Step-in contact": "人工接手联系人",
  "Add the person the receptionist can call when a caller needs a human answer.": "添加客户需要真人答复时接待员可以联系的人。",
  "What service do you need?": "你需要哪项服务？",
  "Which day or time works best?": "哪一天或哪个时间最合适？",
  "Requests outside the listed services": "不在已列服务范围内的请求",
  "Password reset is not ready for this business yet.": "这个商家暂时还不能重置密码。",
  "We could not send a reset email.": "暂时无法发送重置邮件。",
  "If this email has access, a password reset link has been sent.": "如果这个邮箱有访问权限，重置链接已经发送。",
  "Use at least 8 characters for the new password.": "新密码至少需要 8 个字符。",
  "The passwords do not match.": "两次输入的密码不一致。",
  "We could not reset the password.": "暂时无法重置密码。",
  "Password updated. You can sign in with the new password.": "密码已更新。现在可以使用新密码登录。",
  "Set a new password": "设置新密码",
  "Reset your password": "重置密码",
  "Choose a new password for your Attenda account.": "为你的 Attenda 账号设置新密码。",
  "Enter the email used for your invited account and we will send a reset link.": "输入受邀账号使用的邮箱，我们会发送重置链接。",
  "New password": "新密码",
  "Confirm password": "确认密码",
  "Updating password": "正在更新密码",
  "Update password": "更新密码",
  "Sending reset link": "正在发送重置链接",
  "Send reset link": "发送重置链接",
  "Back to sign in": "返回登录",
  "Loading business": "正在加载业务",
  "Business access denied": "无法访问业务",
  "Business could not load": "业务加载失败",
  "This signed-in account does not have access to the selected business.": "当前登录账号没有访问所选业务的权限。",
  "We could not load this business right now. Retry before changing accounts.": "暂时无法加载这个业务。切换账号前请先重试。",
  "Access": "访问权限",
  "Retry": "重试",
  "Sign in": "登录",
  "Needs attention": "需要处理",
  "needs a refresh": "需要刷新",
  "Reload the page. If it keeps happening, contact support.": "请刷新页面。如果问题持续出现，请联系支持团队。",
  "Reload": "刷新",

  "Team activity": "团队活动",
  "Open business": "打开业务",
  "Operations": "运营",
  "Businesses": "商家",
  "Review call readiness, owners, and customer conversation activity across every business.": "查看每个商家的接听准备、负责人和客户对话活动。",
  "Find a business": "查找商家",
  "Search businesses or owners": "搜索商家或负责人",
  "Clear search": "清除搜索",
  "Search by business, owner, or team member.": "按商家、负责人或团队成员搜索。",
  "{businesses} businesses / {teamMembers} team members": "{businesses} 个商家 / {teamMembers} 位团队成员",
  "{action} for {business}": "{business}：{action}",
  "Businesses under care": "正在管理的商家",
  "Next business to finish": "下一个要完成的商家",
  "Caller-ready coverage": "接听准备覆盖",
  "Work on {business} next": "下一步处理 {business}",
  "Every business is ready for live callers": "所有商家都可以接待真实来电",
  "All visible businesses are ready to answer calls.": "所有可见商家都已准备好接听来电。",
  "{need}: {detail}": "{need}：{detail}",
  "Ready businesses": "已就绪商家",
  "Can handle live callers": "可以接待真实来电",
  "Next caller-ready item": "下一个待完成的接听准备",
  "{count} active team member this week": "{count} 位团队成员本周活跃",
  "{count} active team members this week": "{count} 位团队成员本周活跃",
  "This month": "本月",
  "activity recorded": "条活动记录",
  "Active team members": "活跃团队成员",
  "Active in the last 7 days": "最近 7 天活跃",
  "All time": "全部时间",
  "Merchant": "商家",
  "Industry": "行业",
  "Status": "状态",
  "Owner": "负责人",
  "Caller activity": "来电活动",
  "Progress": "进度",
  "No businesses match this search.": "没有匹配的商家。",
  "Action": "操作",
  "Open": "打开",
  "Needs action": "需处理",
  "Continue setup": "继续设置",
  "Publish answers": "发布答案",
  "Set alerts": "设置提醒",
  "Open next step": "打开下一步",
  "Core setup is in place.": "核心设置已经完成。",
  "Add public business details.": "补全客户会听到的业务信息。",
  "Publish the active receptionist.": "发布当前接待员。",
  "Publish services and answers callers can rely on.": "发布客户可依赖的服务和答案。",
  "Add the hours callers can book.": "添加客户可预约的时段。",
  "Choose where the team receives call updates.": "选择团队接收来电更新的位置。",
  "Fix alert delivery before callers rely on it.": "在客户开始依赖前修复提醒发送。",
  "Add a team phone for calls that need a person.": "添加一个可由团队接听的电话。",
  "Last call {time}": "最近来电 {time}",
  "Administrator": "管理员",
  "Manager": "经理",
  "Viewer": "查看者",
  "Unassigned": "未分配",
  "Recent customer conversations by team member and business.": "按团队成员和商家查看最近客户对话。",
  "Conversation activity will appear after the first live call or receptionist test.": "完成第一通真实电话或接待测试后，对话活动会显示在这里。",
  "No team members match this search.": "没有匹配的团队成员。",
  "Review customer conversation volume by team member and business before billing or call readiness review.": "按团队成员和商家查看客户对话量，用于账单和接听准备检查。",
  "Tracking": "正在记录",
  "Waiting": "等待数据",
  "See where customer conversations are happening": "看清客户对话发生在哪里",
  "Monitor businesses, spot active teams, and keep trial reviews grounded in real customer conversation history.": "查看商家和活跃团队，让试用复盘基于真实客户对话记录。",
  "{count} total conversation": "共 {count} 次对话",
  "{count} total conversations": "共 {count} 次对话",
  "{count} with customer history": "{count} 个有客户记录",
  "Tracked team members": "已记录团队成员",
  "No customer conversations this week": "本周暂无客户对话",
  "Have customer conversation history": "已有客户对话记录",
  "No conversations recorded yet": "暂无对话记录",
  "Most active team member": "最活跃团队成员",
  "{user} in {business}": "{user}，{business}",
  "Activity will appear after the first live conversation.": "第一通真实对话后会显示活动。",
  "Sorted by customer conversations across live calls and receptionist tests.": "按真实电话和接待测试中的客户对话排序。",
  "Search team or businesses": "搜索团队或商家",
  "Conversation mix": "对话结构",
  "Questions": "问题",
  "Replies": "回复",
  "Saved details": "已保存信息",
  "No business assigned": "暂未分配商家",
  "Review business": "查看业务",
  "Review {business}": "查看 {business}",
  "{user} conversation mix": "{user} 的对话结构",
  "No activity": "暂无活动",
  "Quiet": "较少活动",
  "Not recorded": "未记录",
  "User": "用户",
  "Total": "总计",
  "Conversations": "对话",
  "Last active": "最近活跃",
  "Not yet": "暂无",
  "No business": "暂无业务",
  "Active": "活跃",
  "Draft": "草稿",
  "Pending": "待处理",
  "Paused": "已暂停",

  "Overview": "概览",
  "Setup": "设置",
  "Calls": "电话",
  "Leads": "线索",
  "Calendar": "日历",
  "Receptionist": "接待员",
  "Answers": "答案",
  "Phone Numbers": "电话号码",
  "Analytics": "分析",
  "Admin": "管理",
  "Integrations": "集成",
  "Billing": "账单",
  "Settings": "设置",
  "Business": "业务",
  "Dashboard": "工作台",
  "Open page": "打开页面",
  "Search business, {shortcut} or slash": "搜索业务，{shortcut} 或斜杠",
  "Search business": "搜索业务",
  "Search pages, calls, leads, bookings, answers...": "搜索页面、电话、线索、预约和答案...",
  "Toggle navigation": "切换导航",
  "No matching business item.": "没有匹配的业务内容。",
  "Actions": "操作",
  "Pages": "页面",
  "Bookings": "预约",
  "Nothing needs review": "暂无需要处理",
  "New call failures, booking reviews, call readiness items, and delivery issues will appear here.": "新的失败电话、待确认预约、接听准备事项和提醒问题会显示在这里。",
  "View activity": "查看活动",
  "Notifications": "通知",
  "Notifications, {count} unread": "通知，{count} 条未读",
  "Notifications, {count} need review": "通知，{count} 项需要处理",
  "All clear": "全部正常",
  "{count} to review": "{count} 项待处理",
  "to review": "待处理",
  "Trial usage": "试用用量",
  "Trial {calls} calls · {bookings} bookings": "试用：{calls} 通电话 · {bookings} 个预约",
  "Current month for": "本月",
  "Current month for {business}.": "{business} 的本月用量。",
  "this business": "这个业务",
  "Review soon": "尽快查看",
  "On track": "进展正常",
  "Open billing": "打开账单",
  "Offline": "离线",
  "Syncing...": "正在同步...",
  "Sync failed": "同步失败",
  "Dashboard sync failed. Retry.": "工作台同步失败，请重试。",
  "Refresh failed. Try again.": "刷新失败，请重试。",
  "Reconnect to sync dashboard changes.": "重新连接后会同步工作台变更。",
  "Updating business data.": "正在更新业务数据。",
  "Business synced at {time}.": "业务已在 {time} 同步。",
  "Synced {time}": "已同步 {time}",
  "You are offline. Dashboard changes will sync after reconnection.": "你当前离线。重新连接后会同步工作台变更。",
  "Dashboard sync failed. Retry to load the latest business data.": "工作台同步失败。请重试以加载最新业务数据。",
  "Ready": "已就绪",
  "Review": "查看",
  "ready-to-answer checks done": "项接听准备已完成",
  "Handle next item": "处理下一项",
  "Handle next readiness item: {label}": "处理下一项接听准备：{label}",
  "Ready for live calls": "可以接听真实来电",
  "Loading chart": "正在加载图表",
  "{title} page content": "{title} 页面内容",
  "Business settings": "业务设置",
  "Account settings": "账号设置",
  "Finish setup": "完成设置",
  "Sign out": "退出登录",
  "Switch this dashboard to another business.": "切换到另一个业务工作台。",
  "Choose a phone number to go live": "选择电话号码后即可接听",
  "No phone number connected": "尚未连接电话号码",
  "{score}% ready to answer": "接听准备度 {score}%",
  "Next": "下一项",
  "Onboarding": "接听设置",
  "Onboarding progress": "设置进度",
  "Current step": "当前步骤",
  "Not done yet": "待完成",
  "{ready}/{total} setup steps done": "{ready}/{total} 项设置已完成",
  "Call plan recommendation": "接听计划建议",
  "Recommended call plan": "推荐接听计划",
  "Recommended industry templates": "推荐行业模板",
  "Suggested services": "建议服务",
  "Setup packet": "设置清单",
  "Launch packet": "接听准备",
  "First call setup path": "第一通电话设置路径",
  "First live call path": "第一通真实来电路径",
  "Caller dials": "客户拨号",
  "The caller number reaches this business.": "客户号码会进入这个业务。",
  "No number yet": "暂无号码",
  "Receptionist answers": "接待员接听",
  "Greeting, questions, and step-in instructions are published.": "问候、问题和人工介入说明已发布。",
  "Not published": "尚未发布",
  "Request is covered": "需求有答案",
  "Approved answers cover the services callers ask about.": "已批准答案覆盖客户咨询的服务。",
  "Needs answer": "需要答案",
  "Team gets next step": "团队收到下一步",
  "Team will receive call, booking, and step-in alerts.": "团队会收到电话、预约和人工介入提醒。",
  "No alert yet": "暂无提醒",
  "Story": "业务故事",
  "Profile": "资料",
  "Services": "服务",
  "Tell us what callers ask for": "告诉我们客户通常为什么来电",
  "What should callers hear first?": "客户来电时先听到什么？",
  "Where should calls land?": "电话应该接到哪里？",
  "What can callers book or ask about?": "客户可以预约或咨询什么？",
  "How should the receptionist behave?": "接待员应该怎么处理来电？",
  "Who should hear about new calls?": "新来电要通知谁？",
  "Open dashboard": "打开工作台",
  "Review and open your dashboard": "检查后打开工作台",
  "Business context": "业务背景",
  "Approved answers": "已批准答案",
  "Needs content": "需要内容",
  "Owner email": "负责人邮箱",
  "Google Calendar": "Google 日历",
  "Calendar sync": "日历同步",
  "Connected": "已连接",
  "Setup needed": "需要设置",
  "{count} saved": "已保存 {count} 条",
  "Saving this step.": "正在保存这一步。",
  "Saved. Continue with the next setup step.": "已保存。继续下一项设置。",
  "Enough context to recommend a setup.": "信息足够，可以推荐设置。",
  "Describe the callers, common requests, and when a person should step in.": "说明谁会来电、常见请求，以及什么时候需要真人介入。",
  "Caller-facing business details are saved.": "客户会听到的业务信息已保存。",
  "Save the basics callers should hear first.": "先保存客户最需要听到的基础信息。",
  "Caller number is connected.": "客户拨打的号码已连接。",
  "Connect the number customers will call.": "连接客户会拨打的号码。",
  "Services and approved answers are saved.": "服务和已批准答案已保存。",
  "Choose services and save the answer customers can hear.": "选择服务，并保存客户可以听到的答案。",
  "Choose at least one service, or add a custom service.": "选择至少一项服务，也可以添加自定义服务。",
  "Receptionist behavior is published.": "接待员行为已发布。",
  "Publish how the receptionist should greet, book, and bring in a person.": "发布接待员如何问候、预约，以及什么时候请真人介入。",
  "Team alerts are saved.": "团队提醒已保存。",
  "Add the team members who should hear about new calls.": "添加需要收到新来电提醒的团队成员。",
  "Ready to open the dashboard.": "可以打开工作台。",
  "Finish {items} before opening the dashboard.": "完成{items}后即可打开工作台。",
  "the remaining setup": "剩余设置",
  "Finish the unchecked setup items before opening the dashboard.": "打开工作台前，请先完成未勾选的设置项。",
  "Setup still needed": "还需要完成的设置",
  "{count} setup item left": "还剩 {count} 项设置",
  "{count} setup items left": "还剩 {count} 项设置",
  "Open each item below, save it, then return here to enter the dashboard.": "逐项打开并保存，然后回到这里进入工作台。",
  "Open, save, then return here.": "打开并保存，然后回到这里。",
  "Open step": "去处理",
  "All setup steps are saved. You can enter the dashboard now.": "所有设置已保存。现在可以进入工作台。",
  "Important: keep answers concise, confirm caller details, and ask staff to review anything outside the approved information.": "重要：回答要简洁，确认来电人信息；超出已批准信息的内容交给团队复核。",
  "Use approved answers and ask concise booking questions.": "使用已批准答案，并简洁询问预约所需信息。",
  "Hi, you've reached {business}. How can I help today?": "你好，这里是 {business}，请问有什么可以帮你？",
  "Hi, you've reached {business}. I'm the receptionist and can help with bookings and messages. How can I help today?": "你好，这里是 {business}。我是接待员，可以帮你预约或留言，请问有什么可以帮你？",
  "the team": "团队",
  "This step could not be saved.": "这一步暂时无法保存。",
  "This step could not be saved. Check the details and try again.": "这一步暂时无法保存。请检查内容后重试。",
  "Sign in again before continuing setup.": "请重新登录后继续设置。",
  "This business could not be found. Refresh and try again.": "找不到这个业务。请刷新后重试。",
  "Phone number setup is not ready yet. Contact the Attenda team before connecting this number.": "号码接入暂时未就绪。连接号码前请联系 Attenda 团队。",
  "We could not save this step. Check your connection and try again.": "暂时无法保存这一步。请检查网络后重试。",
  "Finish every setup step before entering the dashboard.": "进入工作台前，请先完成所有设置步骤。",
  "A physio clinic booking appointments and moving urgent pain calls to the team, or a plumbing team booking site visits, capturing access notes, and escalating after-hours emergencies...": "例如：物理治疗诊所需要预约，并把紧急疼痛来电交给团队；或水工团队需要预约上门、记录进入说明，并升级处理下班后的紧急情况...",
  "Start with who calls, what they ask for, and when a person should step in.": "先写谁会来电、通常问什么，以及什么时候需要真人介入。",
  "Add a little more detail so the setup matches your callers.": "再补充一点细节，让设置更贴近你的来电客户。",
  "Ready to shape the next setup steps.": "可以继续完成后续设置步骤。",
  "Add caller details to continue": "补充来电信息后继续",
  "Starts with": "从",
  "Starts with {item}": "从{item}开始",
  "Caller details mention \"{value}\"": "来电描述提到“{value}”",
  "Build my {setup}": "生成{setup}设置",
  "setup": "设置",
  "Business name": "业务名称",
  "Public phone": "公开电话",
  "Timezone": "时区",
  "Voice and tone": "语气和风格",
  "Saving": "正在保存",
  "Save profile": "保存资料",
  "Friendly, concise, and professional.": "友好、简洁、专业。",
  "These details drive booking language, local time, and what callers hear.": "这些资料会影响预约表述、本地时间和客户听到的内容。",
  "Business details, local time, and what callers hear.": "业务资料、本地时间，以及客户来电时听到的内容。",
  "Legal name": "法定名称",
  "Default language": "默认语言",
  "Call language": "接电话语言",
  "This only changes what callers hear, not the dashboard language.": "这里只会改变客户来电时听到的语言，不会改变工作台语言。",
  "Not saved": "未保存",
  "Could not save business profile. Check the details and try again.": "暂时无法保存业务资料。请检查内容后重试。",
  "Profile saved. The receptionist will use these details on calls and bookings.": "资料已保存。接待员会在通话和预约中使用这些内容。",
  "Account": "账号",
  "Activity": "活动",
  "Signed-in user and business access.": "当前登录用户和业务访问权限。",
  "Role": "角色",
  "Business access": "业务访问",
  "Businesses this account can open from the dashboard switcher.": "这个账号可在工作台切换器中打开的业务。",
  "No phone number assigned": "尚未分配电话号码",
  "Current business": "当前业务",
  "Active business": "当前打开的业务",
  "Visible businesses": "可见业务数",
  "No calendar": "暂无日历",
  "No calendar yet": "暂未连接日历",
  "Outlook Calendar": "Outlook 日历",
  "Apple Calendar": "Apple 日历",
  "Team coverage": "团队覆盖",
  "Make sure the right person gets each call": "让每通来电都能找到负责人",
  "{business} is ready for live callers when transfer phones, step-in instructions, alerts, and dashboard access all point to a clear team owner.": "{business} 要接待真实来电，需要转接电话、人工介入说明、提醒和工作台权限都指向清晰的团队负责人。",
  "Team call coverage": "团队来电覆盖",
  "Transfer phones": "转接电话",
  "of {count} active staff": "共 {count} 位可接手成员",
  "Add staff first": "先添加成员",
  "Dashboard access": "工作台访问",
  "{count} active member": "{count} 位可访问成员",
  "{count} active members": "{count} 位可访问成员",
  "Team checks": "团队检查",
  "ready": "已就绪",
  "Manage business profile, team access, call readiness, and saved activity.": "管理业务资料、团队访问、接听准备和已保存活动。",
  "Roles": "权限",
  "Caller notice": "来电告知",
  "Approved copy for recording, consent, or call handling disclosure.": "用于录音、同意或来电处理说明的已批准文案。",
  "Privacy handling": "隐私处理",
  "Approved instructions for personal information and customer data.": "用于个人信息和客户资料的已批准处理说明。",
  "Sensitive claim boundaries": "敏感承诺边界",
  "Rules that stop the receptionist from making guarantees or regulated advice claims.": "防止接待员作出保证或受监管建议的边界规则。",
  "Open policies": "打开政策答案",
  "Open boundaries": "打开边界答案",
  "Open team": "打开团队",
  "Open receptionist": "打开接待员",
  "When staff should step in": "什么时候转给团队",
  "{rules} step-in situations and {phones} transfer phones saved.": "已保存 {rules} 种人工介入情况和 {phones} 个转接电话。",
  "Add at least one situation where a person should step in.": "请至少添加一种需要真人介入的情况。",
  "Open numbers": "打开号码",
  "{count} active number assigned.": "已分配 {count} 个可用号码。",
  "{count} active numbers assigned.": "已分配 {count} 个可用号码。",
  "No active number assigned to this business.": "这个业务尚未分配可用号码。",
  "Open calendar": "打开日历",
  "Calendar connection": "日历连接",
  "Calendar links are ready for Google Calendar, Apple Calendar, and Outlook.": "Google 日历、Apple 日历和 Outlook 的日历连接已就绪。",
  "Set up calendar sharing before bookings can appear in calendar apps.": "先设置日历共享，预约才会显示在日历应用里。",
  "Open alerts": "打开提醒",
  "{count} alert type selected.": "已选择 {count} 类提醒。",
  "{count} alert types selected.": "已选择 {count} 类提醒。",
  "Choose where staff should be notified.": "选择团队接收提醒的位置。",
  "{title} updated": "{title} 已更新",
  "{category} answer": "{category}答案",
  "Receptionist rules published": "接待员规则已发布",
  "Notification settings updated": "提醒设置已更新",
  "{count} selected event": "已选择 {count} 个事件",
  "{count} selected events": "已选择 {count} 个事件",
  "Choose a business before updating staff.": "请先选择业务，再更新团队成员。",
  "Choose a business before adding staff.": "请先选择业务，再添加团队成员。",
  "Choose a business before adding access.": "请先选择业务，再添加访问权限。",
  "Use at least 2 characters for the staff name.": "团队成员姓名至少需要 2 个字符。",
  "Use a phone number the receptionist can call for transfers.": "请填写接待员可用于转接的电话号码。",
  "Staff member could not be updated.": "暂时无法更新团队成员。",
  "Staff member could not be saved.": "暂时无法保存团队成员。",
  "Enter a valid email address.": "请输入有效邮箱地址。",
  "Access could not be saved.": "暂时无法保存访问权限。",
  "Needs phone": "需要电话",
  "The receptionist has at least one person to transfer urgent calls to.": "接待员至少可以把紧急来电转给一位团队成员。",
  "Add a callable phone number before urgent callers can be transferred.": "请先添加可拨通电话，紧急来电才能转给团队。",
  "Needs rules": "需要规则",
  "Receptionist instructions explain when a person should step in.": "接待说明已写清什么时候需要真人介入。",
  "Add situations where a person should step into the conversation.": "添加需要真人进入对话的情况。",
  "Needs alert": "需要提醒",
  "Team alerts have at least one place to send updates.": "团队提醒已有至少一个接收位置。",
  "Choose email, Slack, or Telegram before relying on alerts.": "依赖提醒前，请先选择邮箱、Slack 或 Telegram。",
  "Needs access": "需要访问权限",
  "At least the owner can review calls, leads, bookings, and saved activity.": "至少负责人可以查看电话、线索、预约和已保存活动。",
  "Add account access for the person responsible for reviewing calls.": "为负责复核来电的人添加账号访问权限。",
  "Handle calls, follow-ups, and bookings.": "处理电话、跟进和预约。",
  "Manage setup, bookings, staff, and integrations.": "管理设置、预约、团队和连接。",
  "Review calls, bookings, and reports.": "查看电话、预约和报表。",
  "Owner and staff assigned to {business}.": "{business} 的负责人和团队成员。",
  "{count} staff member": "{count} 位成员",
  "{count} staff": "{count} 位成员",
  "Owner only": "仅负责人",
  "Add staff": "添加成员",
  "Add advisers or front desk staff who can own bookings, calendars, and urgent call transfers.": "添加可负责预约、日历和紧急来电转接的顾问或前台成员。",
  "Calendar app": "日历应用",
  "Adding...": "正在添加...",
  "Staff member added.": "团队成员已添加。",
  "No owner email": "暂无负责人邮箱",
  "Add staff who can own bookings, calendars, and urgent call transfers.": "添加可负责预约、日历和紧急来电转接的团队成员。",
  "No staff added yet": "尚未添加团队成员",
  "Edit staff": "编辑成员",
  "Set the phone number the receptionist should use for urgent transfers.": "设置接待员处理紧急转接时应拨打的电话号码。",
  "Transfer ready": "可转接",
  "No transfer": "未设置转接",
  "Save staff": "保存成员",
  "Transfer details saved.": "转接信息已保存。",
  "Transfers to {phone}": "转接至 {phone}",
  "No transfer phone": "暂无转接电话",
  "Can take calls": "可接听来电",
  "Grant dashboard access for {business}.": "为 {business} 分配工作台访问权限。",
  "No access": "暂无访问权限",
  "{count} active access member": "{count} 位成员可访问",
  "{count} active access members": "{count} 位成员可访问",
  "Signed-in role": "当前账号角色",
  "{count} business": "{count} 个业务",
  "{count} businesses": "{count} 个业务",
  "Add account access": "添加账号访问",
  "Choose what this person can do in the dashboard.": "选择这个人在工作台中可以执行的操作。",
  "Save access": "保存访问权限",
  "Only owners and managers can change access.": "只有负责人和经理可以更改访问权限。",
  "Access saved.": "访问权限已保存。",
  "Add the owner and team members who should see this dashboard.": "添加需要查看这个工作台的负责人和团队成员。",
  "No dashboard access yet": "尚未添加工作台访问权限",
  "Disabled": "已停用",
  "Access ready": "访问已就绪",
  "Check approved answers, receptionist instructions, caller number, and team alerts before real calls rely on them.": "在真实来电依赖接待员前，检查已批准答案、接待说明、客户拨打号码和团队提醒。",
  "Recent changes your team can review.": "团队可查看的最近更改。",
  "Saved notes, follow-up actions, answer updates, and receptionist changes will appear here.": "已保存备注、跟进行动、答案更新和接待员更改会显示在这里。",
  "Caller-facing number": "客户拨打的号码",
  "{number} is connected for callers.": "{number} 已可供客户拨打。",
  "Connect the number callers will dial first.": "连接客户会优先拨打的号码。",
  "Confirm number": "确认号码",
  "Connecting": "正在连接",
  "Add another service": "添加其他服务",
  "Use the words callers use when they ask for it.": "用客户来电时会说的服务名称。",
  "Add": "添加",
  "What callers can hear": "客户会听到的答案",
  "Keep this short, approved, and useful for the selected services.": "保持简短、已确认，并适用于所选服务。",
  "Add the answer customers should hear before your team reviews edge cases.": "写下客户可以先听到的答案，特殊情况再交给团队复核。",
  "{count} selected services will use this answer.": "{count} 项已选服务会使用这条答案。",
  "Choose at least one service before saving.": "保存前请至少选择一项服务。",
  "Save services and answers": "保存服务和答案",
  "Opening line": "开场问候",
  "Booking authority": "预约权限",
  "Questions to ask": "需要询问的问题",
  "Publishing": "正在发布",
  "Publish receptionist": "发布接待员",
  "Team alert recipients": "团队提醒收件人",
  "Save alerts": "保存提醒",
  "Opening dashboard": "正在打开工作台",
  "Enter dashboard": "进入工作台",
  "Back": "返回",
  "Write it like you would explain it to a new front desk hire. Attenda will suggest the closest setup and shape the next steps around it.": "像培训新前台一样说明即可。Attenda 会推荐最接近的设置，并围绕它安排后续步骤。",
  "Save the caller-facing business name, phone, timezone, and tone before customers hear the receptionist.": "保存客户会听到的商家名称、电话、时区和语气。",
  "Confirm the number customers dial so incoming calls reach the right business setup.": "确认客户拨打的号码，让来电进入正确的业务设置。",
  "Choose the services callers can book, then save the approved answer they can hear.": "选择客户可以预约的服务，并保存他们可以听到的已批准答案。",
  "Set the greeting, booking authority, questions, and moments that should move to a person.": "设置开场问候、预约权限、要问的问题，以及需要转给真人的情况。",
  "Add the people who should hear about new calls, bookings, and step-in requests.": "添加需要收到来电、预约和人工介入请求的团队成员。",
  "Everything below is saved. Completing onboarding opens the operating dashboard for this business.": "下面的内容都会保存。完成设置后，将打开这个业务的运营工作台。",
  "After opening the dashboard": "打开工作台后",
  "{ready}/{total} ready-to-answer checks done": "{ready}/{total} 项接听准备已完成",
  "The dashboard will keep these call readiness items visible until they are done.": "工作台会持续显示这些接听准备事项，直到全部完成。",
  "Suggest times only": "只建议时间",
  "Book, then team confirms": "先预约，团队确认",
  "Confirm safe bookings": "确认低风险预约",
  "Suggest only": "只建议",
  "Confirm safe": "确认低风险",
  "Team confirms": "团队确认",
  "Choose mode": "选择模式",
  "Set what callers hear, what the receptionist can book, and when a person should step in.": "设置客户会听到什么、接待员可以预约什么，以及什么时候需要真人介入。",
  "Publish before callers use this receptionist.": "先发布接待员，再让客户使用。",
  "Connect an active number.": "连接一个可用号码。",
  "{count} published answer.": "{count} 条已发布答案。",
  "{count} published answers.": "{count} 条已发布答案。",
  "{count} active service": "{count} 项可预约服务",
  "{count} active services": "{count} 项可预约服务",
  "{count} active service.": "{count} 项可预约服务。",
  "{count} active services.": "{count} 项可预约服务。",
  "Step-in instructions": "人工介入说明",
  "{count} step-in instruction.": "{count} 条人工介入说明。",
  "{count} step-in instructions.": "{count} 条人工介入说明。",
  "Add a staff transfer phone.": "添加团队转接电话。",
  "{count} transfer phone.": "{count} 个转接电话。",
  "{count} transfer phones.": "{count} 个转接电话。",
  "Needs work": "需要处理",
  "Test connected": "测试已连接",
  "Test incoming call": "测试来电",
  "Reset": "重置",
  "Publish changes": "发布更改",
  "Ready to test": "可以测试",
  "Voice test connected": "语音测试已连接",
  "Ended": "已结束",
  "Microphone live": "麦克风已开启",
  "Requesting microphone": "正在请求麦克风",
  "Microphone blocked": "麦克风被阻止",
  "Microphone error": "麦克风异常",
  "Microphone ready": "麦克风就绪",
  "Start a voice test to hear this receptionist answer.": "开始语音测试，听接待员如何回答。",
  "Speak normally and listen for the receptionist reply.": "像客户一样正常说话，并听接待员回复。",
  "Allow microphone access to start the incoming-call voice test.": "允许麦克风权限后即可开始来电语音测试。",
  "Allow microphone access in the browser and try again.": "请在浏览器里允许麦克风权限后重试。",
  "Check the microphone device and try again.": "请检查麦克风设备后重试。",
  "Start the test and allow microphone access to hear the receptionist reply.": "开始测试并允许麦克风权限，就能听到接待员回复。",
  "Select a business before trying calls.": "先选择业务，再测试来电。",
  "Publish the receptionist before testing incoming calls.": "先发布接待员，再测试来电。",
  "Publish changes before testing if you want the test to match the latest edits.": "如果希望测试包含最新更改，请先发布。",
  "Receptionist: {value}": "接待员：{value}",
  "Caller: I need help booking {service}.": "客户：我想预约{service}。",
  "Receptionist: {mode}. If this needs staff, I will pause and bring someone in. Example step-in: {rule}": "接待员：{mode}。如果需要团队处理，我会暂停并请团队介入。示例介入情况：{rule}",
  "Receptionist changes are published.": "接待员设置已发布。",
  "Could not publish receptionist settings. Review the changes and try again.": "暂时无法发布接待员设置。请检查更改后重试。",
  "Sign in again before publishing receptionist settings.": "请重新登录后再发布接待员设置。",
  "Receptionist settings could not be saved. Check the details and try again.": "暂时无法保存接待员设置。请检查内容后重试。",
  "Incoming test call connected.": "测试来电已连接。",
  "The reply audio could not play. Try again.": "回复音频无法播放，请重试。",
  "Receptionist action started.": "接待员正在处理。",
  "Receptionist action completed: {summary}": "接待员已完成处理：{summary}",
  "Receptionist action completed.": "接待员已完成处理。",
  "Receptionist action could not finish. Try again.": "接待员未能完成处理，请重试。",
  "Voice test could not continue. Try again.": "语音测试无法继续，请重试。",
  "Test call ended.": "测试来电已结束。",
  "Call guidelines were cleaned up for review. Publish changes to save the clearer wording.": "通话规则已整理成更清晰的说法。发布更改后会保存。",
  "Incoming test call to {business}...": "正在拨入 {business} 的测试来电...",
  "Requesting microphone access for the caller voice test.": "正在请求麦克风权限，用于模拟客户说话。",
  "This browser does not support the microphone audio test.": "这个浏览器暂不支持麦克风语音测试。",
  "Microphone connected. Connecting the receptionist.": "麦克风已连接，正在接入接待员。",
  "Sign-in service is unavailable. Try again in a moment.": "登录服务暂时不可用，请稍后重试。",
  "Sign in again before trying the receptionist.": "请重新登录后再测试接待员。",
  "The test call could not read the latest update. Try again.": "测试来电未能读取最新状态，请重试。",
  "Test call connection failed.": "测试来电连接失败。",
  "Stopped playback. Keep speaking through the microphone.": "已停止播放。请继续通过麦克风说话。",
  "Microphone permission was blocked. Allow microphone access and try again.": "麦克风权限被阻止。请允许麦克风访问后重试。",
  "No microphone was found on this device.": "这个设备没有找到麦克风。",
  "Microphone setup failed. Check the microphone and try again.": "麦克风设置失败。请检查麦克风后重试。",
  "Hi, you've reached {business}. I can help with bookings and messages. How can I help today?": "你好，这里是 {business}。我可以帮你预约或留言，请问有什么可以帮你？",
  "Start every call by introducing yourself for {business}. Use approved business answers, keep replies short, confirm the caller's name, contact details, service, and preferred time before booking, bring in staff for urgent or sensitive situations, and never promise a saved booking before the booking is saved.": "每通电话先代表 {business} 自我介绍。使用已批准的业务答案；回复保持简洁；预约前确认客户姓名、联系方式、服务和偏好时间；紧急或敏感情况请团队介入；预约真正保存前不要承诺已经保存。",
  "Use approved business answers for {business}, keep replies short, confirm the caller's name, contact details, service, and preferred time before booking, bring in staff for urgent or sensitive situations, and never promise a saved booking before the booking is saved.": "使用 {business} 已批准的业务答案；回复保持简洁；预约前确认客户姓名、联系方式、服务和偏好时间；紧急或敏感情况请团队介入；预约真正保存前不要承诺已经保存。",
  "the business": "这个业务",
  "Urgent or unsafe requests": "紧急或不安全请求",
  "urgent or sensitive requests": "紧急或敏感请求",
  "Pricing, refund, or complaint exceptions": "价格、退款或投诉例外",
  "Anything needing a licensed or qualified staff member": "需要持证或专业团队成员处理的事项",
  "Caller full name": "客户全名",
  "Best callback number": "最佳回拨电话",
  "Reason for the call": "来电原因",
  "Preferred appointment time": "偏好的预约时间",
  "Complaints or policy exceptions": "投诉或政策例外",
  "Anything outside the published service list": "超出已发布服务列表的事项",
  "an appointment": "一个预约",
  "Add the opening line callers should hear.": "添加客户来电时会听到的开场问候。",
  "Keep the opening line under 500 characters.": "开场问候请控制在 500 个字符以内。",
  "Add at least one question before booking.": "预约前请至少添加一个问题。",
  "Keep booking questions to 8 or fewer.": "预约问题请控制在 8 个以内。",
  "Keep each booking question under 160 characters.": "每个预约问题请控制在 160 个字符以内。",
  "Add at least one situation that needs a person.": "请至少添加一种需要真人介入的情况。",
  "Keep step-in situations to 12 or fewer.": "人工介入情况请控制在 12 个以内。",
  "Keep each step-in situation under 180 characters.": "每条人工介入情况请控制在 180 个字符以内。",
  "Add call guidelines before publishing.": "发布前请添加通话规则。",
  "Keep call guidelines under 4000 characters.": "通话规则请控制在 4000 个字符以内。",
  "{name} is ready for a voice test.": "{name} 可以进行语音测试。",
  "Published receptionist": "已发布接待员",
  "Selected business": "当前业务",
  "No published receptionist": "暂无已发布接待员",
  "Reconnect mic": "重新连接麦克风",
  "Start voice test": "开始语音测试",
  "Stop": "停止",
  "Receptionist replies play aloud": "接待员回复会直接播放",
  "Speak into the microphone as the caller. The test log will update as you talk.": "像客户一样对着麦克风说话，测试记录会随着对话更新。",
  "Start the voice test and speak as the caller.": "开始语音测试，并像客户一样说话。",
  "Interrupt": "打断",
  "Launch readiness": "接听准备度",
  "{ready}/{total} readiness items done": "{ready}/{total} 项接听准备已完成",
  "Use recommended setup": "使用推荐设置",
  "Booking rules": "预约规则",
  "Add question": "添加问题",
  "Receptionist offers available times; the team creates the booking.": "接待员提供可选时间，由团队创建预约。",
  "Receptionist creates the booking and flags it for team review.": "接待员创建预约，并标记给团队确认。",
  "Receptionist confirms low-risk services inside availability rules.": "接待员在可预约规则内确认低风险服务。",
  "Questions before booking": "预约前要问的问题",
  "Ask these before creating or confirming a booking.": "创建或确认预约前先询问这些内容。",
  "Split booking questions were cleaned up for review. Publish changes to save the cleaner list.": "已整理拆开的预约问题。发布更改后会保存这份更清晰的列表。",
  "Caller question {index}": "客户问题 {index}",
  "Remove question {index}": "移除问题 {index}",
  "Calls that need a human before the receptionist continues.": "这些来电需要团队先处理，接待员再继续。",
  "Urgent or sensitive request": "紧急或敏感请求",
  "Add rule": "添加规则",
  "Split step-in instructions were cleaned up for review. Publish changes to save the cleaner list.": "已整理拆开的人工介入说明。发布更改后会保存这份更清晰的列表。",
  "Step-in instruction {index}": "人工介入说明 {index}",
  "Remove step-in instruction {index}": "移除人工介入说明 {index}",
  "Call guidelines": "通话规则",
  "Add any tone, boundary, or booking rule the receptionist should follow.": "添加接待员需要遵守的语气、边界或预约规则。",
  "Caller preview": "客户听到的预览",
  "{services} active service / {answers} published answers": "{services} 项可预约服务 / {answers} 条已发布答案",
  "{services} active services / {answers} published answers": "{services} 项可预约服务 / {answers} 条已发布答案",
  "Copy preview": "复制预览",
  "Caller hears": "客户会听到",
  "Question {index}": "问题 {index}",
  "Services available": "可用服务",
  "Could not copy the preview.": "暂时无法复制预览。",
  "What should the adviser call be about?": "顾问电话主要要聊什么？",
  "What callback window works best?": "哪个回访时间段最合适？",
  "What name and contact details should the adviser use?": "顾问应该使用哪个姓名和联系方式？",
  "What care do you need help with?": "你需要哪方面的护理或服务？",
  "How urgent is it?": "这件事有多紧急？",
  "Are you an existing patient or client?": "你是现有客户吗？",
  "What job do you need help with?": "你需要我们处理什么工作？",
  "Where is the site and how urgent is it?": "地点在哪里，紧急程度如何？",
  "What access notes or photos should the team know about?": "团队需要知道哪些进入说明或现场照片？",
  "Which treatment are you interested in?": "你想了解或预约哪项护理？",
  "Have you visited us before?": "你之前来过我们这里吗？",
  "Which day and staff member works best?": "哪一天和哪位员工最合适？",
  "What type of matter do you need help with?": "你需要哪类事项的帮助？",
  "Is there a deadline or key document involved?": "是否有截止日期或关键文件？",
  "What callback window and contact details should the team use?": "团队应该用哪个回访时间段和联系方式？",
  "How many people are coming?": "一共几位客人？",
  "Which day and time works best?": "哪一天和哪个时间最合适？",
  "Any dietary notes or special occasion?": "有饮食备注或特殊纪念日吗？",
  "What do you need help with?": "你需要什么帮助？",
  "Which day works best?": "哪一天最合适？",
  "What name and phone number should we use?": "请留下姓名和联系电话。",
  "Advice, calculation, rate, approval, or product recommendation requests": "涉及建议、计算、利率、审批或产品推荐的请求",
  "Insurance claim or policy interpretation": "保险理赔或保单解释",
  "Complaints or urgent settlement issues": "投诉或紧急交割问题",
  "Clinical or medical advice requests": "临床或医疗建议请求",
  "Urgent symptoms or safety concerns": "紧急症状或安全顾虑",
  "Privacy-sensitive record questions": "涉及隐私记录的问题",
  "Safety hazards or active damage": "安全风险或正在发生的损坏",
  "After-hours emergency jobs": "下班后的紧急工作",
  "Quote exceptions or complex site access": "报价例外或复杂进入现场情况",
  "Medical or allergy concerns": "医疗或过敏顾虑",
  "Pricing exceptions": "价格例外",
  "Complaints": "投诉",
  "Legal, tax, accounting, tenancy, or property advice requests": "法律、税务、会计、租赁或物业建议请求",
  "Urgent deadlines or complaints": "紧急截止日期或投诉",
  "Conflict checks or sensitive documents": "利益冲突检查或敏感文件",
  "Large groups or private room requests": "大桌或包间请求",
  "Same-day changes close to booking time": "临近预约时间的当天变更",
  "Urgent or sensitive requests": "紧急或敏感请求",
  "Completed calls": "已完成电话",
  "Missed or failed calls": "未接或失败电话",
  "New follow-ups": "新跟进",
  "New bookings": "新预约",
  "Cancelled bookings": "已取消预约",
  "Notify staff when a call needs a person.": "当来电需要真人介入时提醒团队。",
  "Custom receptionist": "自定义接待员",
  "Today": "今天",
  "Upcoming": "即将到来",
  "New booking": "新预约",
  "Booking operations": "预约运营",
  "Keep caller bookings moving": "让客户预约持续推进",
  "Track today’s appointments, suggested times that need a person, calendar sharing, and the next booking to review.": "查看今天的预约、需要人工确认的建议时间、日历共享，以及下一项待查看预约。",
  "booking": "个预约",
  "bookings": "个预约",
  "active bookings": "有效预约",
  "booking suggestions": "预约建议",
  "Open hours": "可预约时间",
  "Receptionist has booking windows.": "接待员已有可预约时间。",
  "Add open hours before confirming live bookings.": "确认真实预约前，请先添加可预约时间。",
  "{count} window": "{count} 个时间段",
  "{count} windows": "{count} 个时间段",
  "Bookable services": "可预约服务",
  "Services can be booked by staff or the receptionist.": "团队和接待员都可以预约这些服务。",
  "Add at least one bookable service.": "请至少添加一项可预约服务。",
  "{count} service": "{count} 项服务",
  "{count} services": "{count} 项服务",
  "Calendar links are ready.": "日历链接已就绪。",
  "Set up calendar sharing before calendar apps can update.": "先设置日历共享，日历应用才能自动更新。",
  "Staff calendars": "团队日历",
  "At least one staff calendar is known.": "至少已有一个团队日历。",
  "Team bookings can use the business calendar links.": "团队预约可使用业务日历链接。",
  "{count} connected": "已连接 {count} 个",
  "Business calendar": "业务日历",
  "Create": "创建",
  "Confirm or reschedule suggested bookings.": "确认或改期接待员建议的预约。",
  "No booking confirmations waiting.": "暂无等待确认的预约。",
  "Create the next booking from a caller.": "为来电客户创建下一项预约。",
  "Review bookings not added to calendar apps.": "查看尚未加入日历应用的预约。",
  "Every active booking has a calendar path.": "每项有效预约都已有日历路径。",
  "Open windows are available for the receptionist.": "接待员已有可使用的开放时间。",
  "Add open hours before confirming caller bookings.": "确认客户预约前，请先添加可预约时间。",
  "Create bookings, set open hours, and sync them to Google Calendar, Apple Calendar, and Outlook.": "创建预约、设置可预约时间，并同步到 Google 日历、Apple 日历和 Outlook。",
  "All staff": "全部成员",
  "All services": "全部服务",
  "Staff": "团队成员",
  "Service": "服务",
  "All": "全部",
  "Open booking hours": "开放预约时间",
  "{count} open window": "{count} 个开放时间段",
  "{count} open windows": "{count} 个开放时间段",
  "Weekday": "星期",
  "End": "结束",
  "Add open hours": "添加可预约时间",
  "Hours saved": "时间已保存",
  "Saving...": "正在保存...",
  "No open hours yet": "尚未设置开放时间",
  "Add the first open window so the receptionist knows when bookings can be confirmed.": "先添加第一个开放时间段，让接待员知道哪些时间可以确认预约。",
  "Month · Week · Day · Agenda": "月 · 周 · 日 · 列表",
  "Open a booking for caller context": "打开预约可查看来电背景",
  "No matching bookings": "没有匹配的预约",
  "Try a different staff or service filter.": "请尝试更换团队成员或服务筛选。",
  "Loading calendar": "正在加载日历",
  "Caller name": "客户姓名",
  "Choose service": "选择服务",
  "Any staff": "任意成员",
  "Date": "日期",
  "{count} min": "{count} 分钟",
  "confirmed by team": "团队确认",
  "visible in connected calendar apps": "显示在已连接的日历应用中",
  "Add at least one service before creating bookings.": "创建预约前，请至少添加一项服务。",
  "Call note": "通话备注",
  "What did the caller ask for?": "客户想预约或咨询什么？",
  "Caller details were copied from the selected lead.": "已从所选线索带入客户信息。",
  "Create a confirmed booking for a caller and show it in connected calendar apps.": "为来电客户创建已确认预约，并显示在已连接的日历应用中。",
  "Caller name, callback contact, and service are required before the booking can be created.": "创建预约前，需要填写客户姓名、回拨联系方式和服务。",
  "Choose a business before creating a booking.": "请先选择业务，再创建预约。",
  "Caller name is required.": "需要填写客户姓名。",
  "Add a callback phone number or email.": "请添加回拨电话或邮箱。",
  "Add a service before creating a booking.": "创建预约前，请先添加服务。",
  "Choose a valid booking time.": "请选择有效的预约时间。",
  "Choose a future booking time.": "请选择未来的预约时间。",
  "Booking could not be created. Check the details and try again.": "暂时无法创建预约。请检查信息后重试。",
  "Choose a business before adding availability.": "请先选择业务，再添加可预约时间。",
  "Choose a weekday.": "请选择星期。",
  "Start time must be before end time.": "开始时间必须早于结束时间。",
  "Availability could not be saved.": "暂时无法保存可预约时间。",
  "Connect bookings to calendar apps": "连接预约到日历应用",
  "Turn on calendar sharing before Google Calendar, Apple Calendar, or Outlook can connect.": "连接 Google 日历、Apple 日历或 Outlook 前，请先开启日历共享。",
  "Preparing your calendar link.": "正在准备日历链接。",
  "Calendar sharing is not ready right now.": "日历共享暂时未就绪。",
  "{count} booking ready for Google Calendar, Apple Calendar, and Outlook.": "{count} 个预约可同步到 Google 日历、Apple 日历和 Outlook。",
  "{count} bookings ready for Google Calendar, Apple Calendar, and Outlook.": "{count} 个预约可同步到 Google 日历、Apple 日历和 Outlook。",
  "Waiting for calendar sharing setup.": "等待完成日历共享设置。",
  "Opens Google Calendar in a new tab and keeps bookings in sync.": "在新标签页打开 Google 日历，并保持预约同步。",
  "Google Calendar can connect after the public calendar link is ready. Copy the calendar link for now.": "公开日历链接就绪后即可连接 Google 日历。现在可以先复制日历链接。",
  "Add to Google": "添加到 Google",
  "Copy calendar link": "复制日历链接",
  "Opens Apple Calendar on macOS or iOS.": "在 macOS 或 iOS 上打开 Apple 日历。",
  "Open Apple Calendar": "打开 Apple 日历",
  "Copy the calendar link, then add it in Outlook.": "复制日历链接，然后添加到 Outlook。",
  "Copy Outlook link": "复制 Outlook 链接",
  "Preparing": "准备中",
  "Calendar ready": "日历已就绪",
  "Not ready": "未就绪",
  "Google Calendar is ready": "Google 日历已就绪",
  "Opens Google Calendar and keeps future bookings in sync.": "打开 Google 日历，并保持后续预约同步。",
  "{count} booking available in this calendar.": "这个日历中有 {count} 个预约。",
  "{count} bookings available in this calendar.": "这个日历中有 {count} 个预约。",
  "Calendar connected": "日历已连接",
  "Link copied": "链接已复制",
  "Could not copy the calendar link. Use the calendar buttons above or try copying again.": "暂时无法复制日历链接。请使用上方日历按钮，或稍后重试。",
  "Calendar links are ready": "日历链接已就绪",
  "Use Copy calendar link when another calendar app asks for a link.": "其他日历应用需要链接时，使用复制日历链接即可。",
  "Google Calendar can connect after this calendar link is ready. You can copy the calendar link for now.": "这个日历链接就绪后即可连接 Google 日历。现在可以先复制日历链接。",
  "Turn on calendar sharing, then refresh this page to create Google Calendar, Apple Calendar, and Outlook links.": "开启日历共享后刷新页面，即可创建 Google 日历、Apple 日历和 Outlook 链接。",
  "Calendar sharing could not be prepared.": "暂时无法准备日历共享。",
  "Sign in again to prepare calendar links.": "请重新登录后准备日历链接。",
  "You do not have access to this business calendar.": "你没有访问这个业务日历的权限。",
  "This business calendar could not be found.": "找不到这个业务日历。",
  "Calendar sharing is not available right now. Try again shortly.": "日历共享暂时不可用，请稍后重试。",
  "Calendar sharing could not be prepared. Try again.": "暂时无法准备日历共享，请重试。",
  "Agenda": "列表",
  "Month": "月",
  "Week": "周",
  "No bookings in this range.": "这个时间段没有预约。",
  "Answer Library": "答案库",
  "Answer library": "答案库",
  "Answer operations": "答案运营",
  "Approved business answers, services, policies, and test questions.": "管理已批准答案、服务、规则和测试问题。",
  "Keep live calls grounded in approved answers": "让真实来电始终基于已批准答案",
  "Review what callers can hear, check drafts before they are used, and test risky questions before the receptionist takes real calls.": "查看客户会听到什么，草稿使用前先检查，并在接待员接真实电话前测试高风险问题。",
  "Drafts": "草稿",
  "Coverage": "覆盖",
  "live answers": "已发布答案",
  "need review": "需要查看",
  "service, rule, and document answers": "服务、规则和文件答案",
  "Live calls can use approved answers.": "真实来电可以使用已批准答案。",
  "Publish at least one answer before live calls.": "接真实来电前，请至少发布一条答案。",
  "Services are ready for booking answers.": "服务已可用于预约回答。",
  "Add services before promising appointments.": "承诺预约前，请先添加服务。",
  "Call boundaries": "来电边界",
  "The receptionist has rules for risky or sensitive questions.": "接待员已有处理高风险或敏感问题的规则。",
  "Add boundaries for what not to promise.": "请添加哪些内容不能承诺。",
  "{count} rule": "{count} 条规则",
  "{count} rules": "{count} 条规则",
  "Review drafts before they affect live calls.": "草稿影响真实来电前，请先查看。",
  "No draft answers waiting for review.": "暂无等待查看的草稿答案。",
  "{count} draft": "{count} 条草稿",
  "{count} drafts": "{count} 条草稿",
  "Live answers": "已发布答案",
  "Review what live callers can hear now.": "查看真实客户现在会听到什么。",
  "Create and publish the first approved answer.": "创建并发布第一条已批准答案。",
  "Draft review": "草稿查看",
  "Draft imports and edits need a person before calls use them.": "导入和编辑的草稿需要人工查看后才能用于来电。",
  "Import a new source when business content changes.": "业务内容变化时，导入新的来源。",
  "Boundaries": "边界",
  "Check escalation and do-not-say rules.": "检查转接规则和不能说的内容。",
  "Add boundaries before the next live call test.": "下次真实来电测试前，请先添加边界。",
  "Caller test": "客户问题测试",
  "Ask a caller-style question against approved answers.": "用客户会问的问题测试已批准答案。",
  "Add services so booking answers are grounded.": "添加服务，让预约回答有依据。",
  "No services": "暂无服务",
  "Edit": "编辑",
  "Import": "导入",
  "Test": "测试",
  "Add answer": "添加答案",
  "Add an answer": "添加答案",
  "Edit answer": "编辑答案",
  "Publish business-approved answers the receptionist can use in live calls.": "发布业务已批准的答案，接待员即可在真实来电中使用。",
  "Choose a business before saving an answer.": "请先选择业务，再保存答案。",
  "Title and approved answer are required.": "需要填写标题和已批准答案。",
  "Answer could not be saved. Check the details and try again.": "暂时无法保存答案。请检查内容后重试。",
  "Title": "标题",
  "Category": "分类",
  "Reference link": "参考链接",
  "Approved answer": "已批准答案",
  "Receptionist preview": "接待员预览",
  "Add content to preview how the receptionist can use it.": "添加内容后即可预览接待员会如何使用。",
  "Save draft": "保存草稿",
  "Publishing...": "正在发布...",
  "Publish": "发布",
  "Documents": "文件",
  "Escalation rules": "转接规则",
  "FAQs": "常见问题",
  "General answers": "通用答案",
  "Locations": "地点",
  "Policies": "规则",
  "Team": "团队",
  "Booking": "预约",
  "Policy": "规则",
  "Matched answer": "匹配答案",
  "No answer": "暂无答案",
  "Best available": "当前可用",
  "{count} answer": "{count} 条答案",
  "{count} answers": "{count} 条答案",
  "Search answers": "搜索答案",
  "Search answers, policies, services...": "搜索答案、规则、服务...",
  "Filter answers by category": "按分类筛选答案",
  "All categories": "全部分类",
  "Try another category or search term.": "请换一个分类或搜索词。",
  "No answers": "暂无答案",
  "Select an answer": "选择答案",
  "Review how the receptionist will answer.": "查看接待员会如何回答。",
  "Pick an answer from the list.": "从列表中选择一条答案。",
  "Try a caller question": "试一个客户问题",
  "Caller question": "客户问题",
  "No approved answer is ready yet.": "还没有可用的已批准答案。",
  "Publish at least one answer before trying caller questions.": "试用客户问题前，请至少发布一条答案。",
  "Close answer found.": "已找到接近的答案。",
  "No close answer found. Showing the first published answer.": "没有找到接近答案，先显示第一条已发布答案。",
  "No close answer found. Showing the first active draft answer.": "没有找到接近答案，先显示第一条可用草稿。",
  "Business summary": "业务摘要",
  "Business summary was cleaned up for review. Save profile to keep the clearer wording.": "业务摘要已整理成更清晰的说法。保存资料后会保留。",
  "Add a short business summary before publishing the receptionist.": "发布接待员前，请先添加简短业务摘要。",
  "Duration: {count} minutes.": "时长：{count} 分钟。",
  "Price: {price}.": "价格：{price}。",
  "Team approval is required before confirming.": "确认前需要团队批准。",
  "The receptionist can book this inside availability rules.": "接待员可在可预约时间内创建预约。",
  "Booking boundaries": "预约边界",
  "New answer": "新答案",
  "The receptionist can suggest available times, create bookings inside configured rules, and escalate price exceptions or sensitive cases to staff.": "接待员可以建议可用时间、按规则创建预约，并把价格例外或敏感情况转交团队。",
  "Trading name": "营业名称",
  "Brand tone": "品牌语气",
  "Friendly and concise": "友好且简洁",
  "Add the business summary from Settings before callers hear the receptionist.": "客户听到接待员前，请先在设置中添加业务摘要。",
  "Add service": "添加服务",
  "Services become bookable in Calendar and available to the receptionist.": "服务会进入日历预约，并可供接待员使用。",
  "Service saved": "服务已保存",
  "Service name": "服务名称",
  "Description": "说明",
  "What should the receptionist know before booking this service?": "接待员预约这项服务前需要知道什么？",
  "Duration": "时长",
  "Duration (minutes)": "时长（分钟）",
  "Buffer": "间隔",
  "Buffer (minutes)": "间隔（分钟）",
  "Team approval": "团队确认",
  "Required": "需要",
  "Not required": "不需要",
  "No services yet": "暂无服务",
  "Add at least one service so the receptionist can answer and book accurately.": "请至少添加一项服务，让接待员能准确回答并预约。",
  "Add answers for common caller questions.": "添加常见客户问题的答案。",
  "No FAQs yet": "暂无常见问题",
  "Add booking rules, risk boundaries, and things the receptionist should not say.": "添加预约规则、风险边界，以及接待员不能说的内容。",
  "No policies yet": "暂无规则",
  "Do not say": "不能说",
  "Upload a plain document or exported table for team review.": "上传普通文档或导出的表格，供团队查看。",
  "Draft ready": "草稿已就绪",
  "Draft import": "草稿导入",
  "Upload file": "上传文件",
  "Use a plain text document or exported table.": "使用普通文档或导出的表格。",
  "Use a smaller file.": "请使用更小的文件。",
  "Selected: {name}": "已选择：{name}",
  "Choose file": "选择文件",
  "Importing...": "正在导入...",
  "Document imported as a draft. Review the opened answer, then save or publish it.": "文件已作为草稿导入。请查看打开的答案，然后保存或发布。",
  "Choose a business before importing a document.": "请先选择业务，再导入文件。",
  "The selected file did not include readable text.": "所选文件没有可读取的文字。",
  "Document could not be imported. Check the file and try again.": "暂时无法导入文件。请检查文件后重试。",
  "Document: {name}": "文件：{name}",
  "Website link": "网站链接",
  "Import a public page into the answer library for team review.": "把公开页面导入答案库，供团队查看。",
  "Import draft": "导入草稿",
  "Website imported as a draft answer. Review it before publishing.": "网站内容已作为草稿答案导入。发布前请先查看。",
  "Choose a business before importing website content.": "请先选择业务，再导入网站内容。",
  "Enter a website link to import.": "请输入要导入的网站链接。",
  "Website could not be imported. Check the link and try again.": "暂时无法导入网站内容。请检查链接后重试。",
  "Sign in again before importing website content.": "请重新登录后导入网站内容。",
  "Test answer": "测试答案",
  "Check how the receptionist would answer before a live test call.": "真实来电测试前，先查看接待员会如何回答。",
  "Preview answer": "预览答案",
  "Draft answer": "答案草稿",
  "No preview yet": "尚未预览",
  "Caller question: {question}": "客户问题：{question}",
  "Choose a question and run preview.": "输入问题并运行预览。",
  "Answer used": "使用的答案",
  "Reason": "原因",
  "Matched words": "匹配词",
  "Close answer found": "已找到接近答案",
  "Best available answer": "当前可用答案",
  "The preview will show the answer and why it was chosen.": "预览会显示答案，以及为什么选择它。",
  "Run preview": "运行预览",
  "Enter a caller question before previewing an answer.": "预览答案前，请先输入客户问题。",
  "Choose a business before adding a service.": "请先选择业务，再添加服务。",
  "Service name is required.": "需要填写服务名称。",
  "Duration must be between 1 and 480 minutes.": "时长需要在 1 到 480 分钟之间。",
  "Buffer must be between 0 and 240 minutes.": "间隔需要在 0 到 240 分钟之间。",
  "Service could not be saved.": "暂时无法保存服务。",
  "Opening hours": "营业时间",
  "Open Monday to Friday, 8:30am to 5:00pm. Urgent pain calls should be offered the earliest emergency slot.": "周一至周五 8:30 到 17:00 营业。紧急疼痛来电应优先安排最早的急诊时段。",
  "Emergency appointment price": "紧急预约价格",
  "Emergency appointments start from $180. The assistant can share the starting price but must not promise a final treatment cost.": "紧急预约起价 $180。接待员可以说明起价，但不能承诺最终治疗费用。",
  "Cancellation policy": "取消规则",
  "Ask callers to give at least 24 hours notice when cancelling. Same-day urgent changes should be escalated to the front desk.": "请客户取消时至少提前 24 小时通知。同日紧急改动需要转交前台处理。",
  "Do not diagnose": "不要诊断",
  "The assistant must not diagnose dental conditions or promise treatment outcomes. It can book care and explain what the clinic will check.": "接待员不能诊断牙科情况，也不能承诺治疗结果。可以预约护理，并说明诊所会检查哪些内容。",
  "Business overview and call policy": "业务概况和接听规则",
  "Escalation policy": "转接规则",
  "Advice boundary": "建议边界",
  "Route urgent, sensitive, complaint, privacy, billing, or policy-exception requests to the human team instead of improvising.": "把紧急、敏感、投诉、隐私、账单或规则例外的来电转交团队，不要临场发挥。",
  "Can I book a consultation this week?": "这周可以预约一次咨询吗？",
  "Can I speak with an adviser about refinancing this week?": "这周可以和顾问聊一下转贷吗？",
  "Appointment-only mortgage adviser desk. The assistant books calls and leaves advice, calculations, rates, approvals, and product recommendations to advisers.": "只处理预约的房贷顾问接待台。接待员负责预约电话，把建议、计算、利率、审批和产品推荐留给顾问处理。",
  "Calm, appointment-focused, and compliant": "冷静、专注预约、符合合规要求",
  "Professional services office handling new enquiry triage, callback booking, and document checklist collection.": "专业服务办公室，用于分流新咨询、预约回访并收集文件清单。",
  "Book adviser callbacks, Capture appointment-ready notes, Avoid advice and calculations": "预约顾问回访、记录可用于预约的要点，并避免建议和计算",
  "Book or change appointments, Escalate urgent symptoms, Protect privacy and avoid diagnosis": "预约或改期、转接紧急症状，并保护隐私避免诊断",
  "Book site visits, Send urgent work to the team, Prepare clear appointment notes": "预约上门、把紧急工作交给团队，并准备清晰预约记录",
  "Book services by duration, Explain deposit rules, Handle reschedules": "按服务时长预约、说明订金规则，并处理改期",
  "Book the right callback, Capture document-prep needs, Avoid professional advice": "预约合适回访、记录文件准备需求，并避免专业建议",
  "Confirm table slots, Escalate large tables, Capture special requests": "确认订位时间、转交大桌需求，并记录特殊需求",
  "Emergency tooth pain": "紧急牙痛",
  "Mortgage consultation": "房贷咨询",
  "Consultation": "咨询",
  "Emergency appointment": "紧急预约",
  "Existing customer message": "现有客户留言",
  "Team callback": "团队回访",
  "General appointment": "普通预约",
  "Borrowing power call": "借贷能力咨询",
  "First home purchase consultation": "首次购房咨询",
  "Interested in refinancing.": "有转贷意向。",
  "Dinner table for 6": "6 人晚餐订位",
  "Hygiene clean": "洁牙护理",
  "Ava reported tooth pain and accepted the earliest emergency slot.": "Ava 提到牙痛，并接受了最早的紧急时段。",
  "Mia wants a facial consult and asked for staff confirmation before the deposit link.": "Mia 想预约面部护理咨询，并希望团队确认后再发送订金链接。",
  "Noah booked a dinner table for six with dietary notes.": "Noah 预订了 6 人晚餐，并留下饮食备注。",
  "Leo cancelled and asked to be called next week.": "Leo 已取消预约，并希望下周再联系。",
  "Custom": "自定义",
  "Not connected": "未连接",
  "Warm, concise, and professional": "温和、简洁、专业",
  "Mortgage adviser appointment desk": "房贷顾问预约台",
  "Mortgage": "房贷顾问",
  "Loan adviser": "贷款顾问",
  "Dentist": "牙科诊所",
  "Trades": "技工服务",
  "Beauty": "美容/沙龙",
  "Professional": "专业服务",
  "Beauty salon": "美容/沙龙",
  "Restaurant": "餐厅",
  "Clinics, dental, physio & vet": "诊所、牙科、物理治疗和兽医",
  "Trades & home services": "技工和上门服务",
  "Beauty, salon & wellness": "美容、沙龙和养生",
  "Legal, accounting & property management": "法律、会计和物业管理",
  "Appointment booking, callback capture, compliance-safe language, and clear adviser follow-up.": "预约顾问电话、记录回访信息，用合规话术安排清晰的顾问跟进。",
  "High-volume bookings, changes, cancellations, FAQs, and urgent care requests.": "处理大量预约、改期、取消、常见问题和紧急护理请求。",
  "Job appointments, site details, urgent requests, and clear appointment notes.": "预约上门、记录现场信息、处理紧急请求，并生成清晰预约记录。",
  "Consults, deposits, patch-test questions, reschedules, and staff-sensitive bookings.": "处理咨询、订金、皮试问题、改期，以及需要团队判断的预约。",
  "Appointment requests, callback booking, document checklists, and qualified-person review.": "处理预约请求、预约回访、收集文件清单，并让合适人员查看专业问题。",
  "Table bookings, party-size rules, waitlists, and special requests.": "处理订位、人数规则、候补名单和特殊需求。",
  "Triage urgent pain, book hygiene and exam slots, capture insurance context, and escalate complex cases.": "分流紧急疼痛、预约洁牙和检查时段、记录保险信息，并把复杂情况转交团队。",
  "Qualify loan intent, collect broad figures, book adviser callbacks, and keep disclaimers clear.": "了解贷款意向、记录大致信息、预约顾问回访，并保持清晰的边界说明。",
  "Match services, staff, rooms, durations, deposit expectations, and patch-test rules.": "匹配服务、员工、房间、时长、订金要求和皮试规则。",
  "Book adviser calls, capture non-sensitive callback notes, and send advice or calculation requests to a licensed adviser.": "预约顾问电话，记录非敏感回访信息，并把建议或计算类问题交给持牌顾问。",
  "Handle high-volume bookings, changes, cancellations, FAQs, and urgent care requests without giving clinical advice.": "处理高频预约、改期、取消、常见问题和紧急护理请求，但不提供临床建议。",
  "Capture appointment requests, site details, urgency, and after-hours messages for missed-call-heavy service teams.": "为经常漏接电话的服务团队记录预约请求、现场信息、紧急程度和下班后留言。",
  "Match services, staff, rooms, durations, deposit expectations, patch-test rules, and simple reschedules.": "匹配服务、员工、房间、时长、订金规则、皮试要求和简单改期。",
  "Sort appointment requests, book callbacks, collect document-prep notes, and send advice questions to a qualified person.": "整理预约请求、预约回访、收集文件准备信息，并把专业建议问题交给合适人员。",
  "Take bookings, manage party size rules, special requests, waitlists, and large-table requests.": "接受订位，管理人数规则、特殊需求、候补名单和大桌请求。",
  "Clear, measured, and compliant": "清楚、稳妥、合规",
  "Calm, practical, and reassuring": "冷静、实用、让人安心",
  "Direct, practical, and local": "直接、实用、本地化",
  "Warm, concise, and premium": "温暖、简洁、有高级感",
  "Structured, careful, and plain-spoken": "有结构、谨慎、说人话",
  "Friendly, fast, and hospitality-led": "友好、迅速、有服务感",
  "Mortgage adviser callback": "房贷顾问回访",
  "Refinance appointment": "转贷预约",
  "First-home buyer call": "首次购房咨询",
  "Insurance adviser call": "保险顾问电话",
  "Document preparation call": "文件准备电话",
  "New patient booking": "新客户预约",
  "New patient exam": "新客户检查",
  "Appointment change": "更改预约",
  "Urgent care triage": "紧急护理分流",
  "Repeat visit": "复诊/复访",
  "General FAQ": "常见问题",
  "Job callback": "工作回访",
  "Site visit booking": "上门预约",
  "Urgent repair appointment": "紧急维修预约",
  "After-hours message": "下班后留言",
  "Maintenance booking": "维护预约",
  "Hair colour": "染发",
  "Facial consult": "面部护理咨询",
  "Wellness appointment": "养生预约",
  "Lash appointment": "睫毛预约",
  "Reschedule or cancellation": "改期或取消",
  "New enquiry callback": "新咨询回访",
  "Appointment request": "预约请求",
  "Existing client message": "现有客户留言",
  "Urgent matter review": "紧急事项查看",
  "Dinner table": "晚餐订位",
  "Large group": "多人订位",
  "Private room": "包间",
  "Waitlist": "候补名单",
  "Buying": "正在购买",
  "Refinancing": "转贷",
  "Borrowing power": "借贷能力",
  "Rate review": "利率复盘",
  "Whitening consult": "美白咨询",
  "Facial": "面部护理",
  "Injectables consult": "注射美容咨询",
  "Book adviser callbacks": "预约顾问回访",
  "Capture appointment-ready notes": "记录可用于预约的要点",
  "Avoid advice and calculations": "避免建议和计算",
  "Book or change appointments": "预约或更改时间",
  "Escalate urgent symptoms": "转接紧急症状",
  "Protect privacy and avoid diagnosis": "保护隐私并避免诊断",
  "Book site visits": "预约上门",
  "Send urgent work to the team": "把紧急工作交给团队",
  "Prepare clear appointment notes": "准备清晰的预约记录",
  "Book services by duration": "按服务时长预约",
  "Explain deposit rules": "说明订金规则",
  "Handle reschedules": "处理改期",
  "Book the right callback": "预约合适的回访",
  "Capture document-prep needs": "记录文件准备需求",
  "Avoid professional advice": "避免专业建议",
  "Confirm table slots": "确认订位时间",
  "Escalate large tables": "转交大桌需求",
  "Capture special requests": "记录特殊需求",
  "Book the right appointment type": "预约合适的服务类型",

  "Business profile": "业务资料",
  "Add details": "补充资料",
  "Connect number": "连接号码",
  "Published": "已发布",
  "Booking windows": "可预约时段",
  "Team alerts": "团队提醒",
  "Team step-in": "团队介入",
  "Add alert": "添加提醒",
  "Add hours": "添加营业时间",
  "Add team phone": "添加团队电话",
  "Add transfer phone": "添加转接电话",
  "Add answers": "添加答案",
  "This business": "这个业务",
  "Google connected": "Google 已连接",
  "Calendar link ready": "日历链接已就绪",
  "Connect calendar": "连接日历",
  "live": "进行中",
  "Live": "进行中",
  "active": "活跃",
  "confirmed": "已确认",
  "completed": "已完成",
  "booked": "已预约",
  "published": "已发布",
  "pending": "待处理",
  "needs confirmation": "需要确认",
  "needs review": "需要查看",
  "onboarding": "设置中",
  "suggested": "已建议",
  "retrying": "重试中",
  "cancelled": "已取消",
  "failed": "失败",
  "paused": "已暂停",
  "draft": "草稿",
  "no show": "未到场",
  "{count} issue": "{count} 个问题",
  "{count} issues": "{count} 个问题",
  "{count} channel": "{count} 个渠道",
  "{count} channels": "{count} 个渠道",
  "{count} transfer phone": "{count} 个转接电话",
  "{count} transfer phones": "{count} 个转接电话",
  "{published} live / {services} service": "{published} 条已发布 / {services} 项服务",
  "{published} live / {services} services": "{published} 条已发布 / {services} 项服务",
  "{count} active": "{count} 个可预约时段",
  "{count} live": "{count} 条已发布",
  "channel": "个渠道",
  "channels": "个渠道",
  "issue": "个问题",
  "issues": "个问题",
  "{item} needs setup": "{item}需要设置",
  "{detail}. Finish this before live calls rely on the receptionist.": "{detail}。请先完成这一项，再让接待员接待真实来电。",
  "Launch": "上线",
  "Setup in progress": "正在设置",
  "Setup is still in progress": "设置仍在进行中",
  "An owner or manager needs to finish setup before this dashboard opens.": "需要负责人或管理员完成设置后，这个工作台才会开放。",
  "You will be able to review calls, bookings, and follow-up once setup is complete.": "设置完成后，你就可以查看电话、预约和跟进事项。",
  "Waiting for setup": "等待完成设置",
  "Your access": "你的权限",
  "Business status": "业务状态",
  "Owner or manager finishes setup": "负责人或管理员完成设置",
  "Who can finish setup": "谁可以完成设置",
  "Setup changes need approval": "设置更改需要批准",
  "Ask an owner or manager to change setup. You can still review calls, leads, bookings, and reports.": "请负责人或管理员更改设置。你仍然可以查看电话、线索、预约和报表。",
  "Your access is still active for daily review work.": "你的权限仍可用于日常查看工作。",
  "Approval needed": "需要批准",
  "Needed access": "所需权限",
  "Owner or manager": "负责人或管理员",
  "Team member or manager": "团队成员或管理员",
  "Available work": "可处理内容",
  "Calls, leads, bookings, reports": "电话、线索、预约、报表",
  "Who can help": "谁可以协助",
  "Review calls": "查看电话",
  "Refreshing": "正在刷新",
  "Refresh status": "刷新状态",
  "You can switch to another business from the menu above if one is already active.": "如果已有其他可用业务，可以从上方菜单切换。",
  "Receptionist live": "接待员可接听",
  "Live call in progress": "正在接听电话",
  "Call readiness incomplete": "接听准备未完成",
  "Setup complete": "设置已完成",
  "Your dashboard is open. Finish the next live-call check.": "工作台已打开。继续完成下一项真实来电检查。",
  "Finish call readiness before the next call.": "下一通电话前完成接听准备。",
  "Today’s front desk is under control.": "今天的前台运行正常。",
  "{subject} is on a live call.": "{subject} 正在通话中。",
  "Onboarding is done. Keep {item} visible here until the first live calls are fully covered.": "入门设置已完成。{item} 会继续显示在这里，直到真实来电完全覆盖。",
  "{item} still needs attention before this business handles live callers.": "{item} 还需要处理，之后这个业务才能接待真实来电。",
  "{business} has its caller number, answers, booking rules, and staff alerts ready.": "{business} 已准备好客户号码、答案、预约规则和团队提醒。",
  "Fix launch item": "处理接听准备",
  "Fix {item}": "处理{item}",
  "Review bookings": "查看预约",
  "Test receptionist": "测试接待员",
  "Call readiness": "接听准备",
  "Production health": "运行状态",
  "Next booking": "下一次预约",
  "No booking queued": "暂无预约排队",
  "Calls today": "今日电话",
  "Calls handled today": "今天已处理的电话",
  "Bookings today": "今日预约",
  "Scheduled for today": "今天已安排",
  "Open leads": "待跟进线索",
  "{count} callers still need follow-up": "{count} 位客户仍需跟进",
  "No open follow-up work yet": "暂无待跟进事项",
  "{count} saved actions already closed or booked": "{count} 条行动已完成或已预约",
  "Needs review": "待处理",
  "Calls, leads, bookings, readiness items, or alerts needing review": "待处理的电话、线索、预约、接听准备事项或提醒",
  "Recent calls": "最近电话",
  "Upcoming bookings": "即将到来的预约",
  "Answer coverage": "答案覆盖",
  "published answer": "条已发布答案",
  "published answers": "条已发布答案",
  "Today’s priorities": "今日重点",
  "{calls} calls to review / {leads} follow-ups / {gaps} readiness items": "{calls} 通电话需复核 / {leads} 个跟进 / {gaps} 个接听准备事项",
  "Handle next": "处理下一项",
  "No calls, follow-ups, readiness items, or draft answers are waiting.": "暂无待处理电话、跟进、接听准备事项或草稿答案。",
  "Queue clear": "暂无待处理",
  "Call answered by the receptionist.": "接待员已处理这通电话。",
  "Booking request captured.": "已记录预约请求。",
  "Payment link requested.": "客户需要付款链接。",
  "Callback booked.": "已预约回访。",
  "Appointment consultation": "预约咨询",
  "Confirm suggested bookings": "确认建议预约",
  "Confirm": "确认",
  "Pick date": "选择日期",
  "Call inbox": "电话收件箱",
  "Call detail": "电话详情",
  "This call could not be found in the current business.": "当前业务中找不到这通电话。",
  "{direction} call · {time}": "{direction} · {time}",
  "Review calls, summaries, transcripts, and follow-up work.": "查看电话处理结果、摘要、记录和后续跟进。",
  "Search calls": "搜索电话",
  "All dates": "全部日期",
  "All calls": "全部电话",
  "Follow-up saved": "已保存跟进",
  "Follow-up": "跟进",
  "Done": "已完成",
  "Failed": "失败",
  "{count} call": "{count} 通电话",
  "{count} calls": "{count} 通电话",
  "Try another day or status.": "换一天或换一个状态试试。",
  "Try another status filter.": "换一个状态筛选试试。",
  "No calls match that search.": "没有匹配的电话。",
  "No calls": "暂无电话",
  "No leads": "暂无线索",
  "Next step": "下一步",
  "Next action": "下一步",
  "Last touch": "最近跟进",
  "Started": "开始时间",
  "Call summary": "电话摘要",
  "Loading the saved summary.": "正在加载已保存摘要。",
  "Conversation summary could not be loaded.": "无法加载通话摘要。",
  "No summary has been saved for this call yet.": "这通电话还没有保存摘要。",
  "Transcript excerpt": "记录摘录",
  "{count} lines": "{count} 行",
  "No transcript": "暂无记录",
  "Conversation record could not be loaded.": "无法加载通话记录。",
  "Loading the saved transcript.": "正在加载已保存记录。",
  "No transcript has been saved for this call yet.": "这通电话还没有保存记录。",
  "Open booking": "打开预约",
  "Book": "预约",
  "Resolved": "已处理",
  "Action saved": "行动已保存",
  "Add note": "添加备注",
  "Team note": "团队备注",
  "What should the team remember before follow-up?": "团队跟进前需要记住什么？",
  "Save note": "保存备注",
  "Action could not be saved. Try again.": "行动未能保存。请重试。",
  "Add a note before saving.": "保存前请先填写备注。",
  "Note could not be saved. Try again.": "备注未能保存。请重试。",
  "Create booking": "创建预约",
  "Send info": "发送资料",
  "Create follow-up": "创建跟进",
  "Send follow-up": "发送跟进",
  "Review call status": "检查电话状态",
  "Review failed call": "查看失败电话",
  "Review call": "查看电话",
  "Review call from {caller}": "查看 {caller} 的电话",
  "Listen in": "接入查看",
  "Do not call": "不要再联系",
  "Check number": "核对号码",
  "No team touch": "暂无团队跟进",
  "Review the outcome and decide whether a person needs to follow up.": "查看处理结果，并决定是否需要人工跟进。",
  "Caller": "来电人",
  "A caller": "一位来电人",
  "the caller": "这位来电人",
  "Inbound call": "来电",
  "Outbound call": "外呼",
  "Browser simulation": "浏览器测试",
  "Summary": "摘要",
  "Outcome": "结果",
  "Direction": "方向",
  "Time": "时间",
  "No calls yet": "暂无电话",
  "New calls will appear here after the receptionist handles them.": "接待员处理来电后，新电话会显示在这里。",
  "Every booking shows what happened and whether a person confirmed it.": "每个预约都会显示发生了什么，以及是否已经由人工确认。",
  "Bookings created by the receptionist will appear here.": "接待员创建的预约会显示在这里。",
  "No bookings": "暂无预约",
  "Booking detail": "预约详情",
  "Review booking details.": "查看预约详情。",
  "Booking action": "预约动作",
  "Confirmation": "确认状态",
  "Receptionist suggested a time": "接待员建议了时间",
  "Receptionist created booking": "接待员创建了预约",
  "Team-created booking": "团队创建的预约",
  "Needs confirmation": "需要确认",
  "Confirmed": "已确认",
  "Created by": "创建来源",
  "Team member": "团队成员",
  "Website form": "网站表单",
  "Manual entry": "手动录入",
  "Calendar link": "日历链接",
  "Not added to calendar": "尚未加入日历",
  "Caller summary": "客户摘要",
  "No summary recorded yet.": "暂未记录摘要。",
  "Call notes will appear after the call is processed.": "电话处理完成后会显示通话备注。",
  "Schedule": "日程",
  "Closed bookings are kept for calendar history.": "已关闭的预约会保留在日历历史中。",
  "Change the time or cancel the booking.": "可以修改时间或取消预约。",
  "Team confirmation needed": "需要团队确认",
  "Confirm the caller's requested slot after checking capacity, or reschedule before confirming.": "确认前请先检查容量，再确认客户希望的时段；必要时先改期。",
  "Minutes": "分钟",
  "Booking time updated.": "预约时间已更新。",
  "Booking confirmed.": "预约已确认。",
  "Booking cancelled.": "预约已取消。",
  "Booking could not be updated. Try again.": "预约未能更新。请重试。",
  "Booking could not be confirmed. Try again.": "预约未能确认。请重试。",
  "Booking could not be cancelled. Try again.": "预约未能取消。请重试。",
  "Press Confirm cancel to cancel this booking.": "再次点击确认取消，即可取消这个预约。",
  "No booking selected": "未选择预约",
  "Open a booking from the calendar or booking list to review it.": "从日历或预约列表打开一个预约进行查看。",
  "Confirming...": "正在确认...",
  "Close edit": "关闭编辑",
  "Save time": "保存时间",
  "Reschedule": "改期",
  "Cancelling...": "正在取消...",
  "Confirm cancel": "确认取消",
  "Cancel booking": "取消预约",
  "Track calls, bookings, follow-ups, and review work for this business.": "查看这个业务的电话、预约、跟进和待处理事项。",
  "All calls for this business": "这个业务的全部电话",
  "Bookings on the calendar": "日历上的预约",
  "{count} call needs a human look": "{count} 通电话需要人工查看",
  "{count} calls need a human look": "{count} 通电话需要人工查看",
  "{completionRate} completed / {followUpCoverage} follow-up coverage": "{completionRate} 已完成 / {followUpCoverage} 跟进覆盖",
  "Booking rate": "预约率",
  "Team report": "团队摘要",
  "Give the team a clear caller summary": "给团队一份清晰的来电摘要",
  "Caller summary preview": "来电摘要预览",
  "Copy report": "复制摘要",
  "Email report": "邮件发送摘要",
  "Copy failed. Email report still includes the current team summary.": "复制失败。邮件摘要仍包含当前团队摘要。",
  "Team report text": "团队摘要文本",
  "Calls and bookings": "电话和预约",
  "Last seven days of calls and bookings for this business.": "这个业务最近 7 天的电话和预约。",
  "Calls and bookings will appear here once this business has activity in the last seven days.": "这个业务最近 7 天有活动后，电话和预约会显示在这里。",
  "No recent activity": "暂无近期活动",
  "Today’s operating focus": "今日运营重点",
  "Jump straight into the work that changes caller outcomes.": "直接进入最影响客户结果的工作。",
  "Open the Calls review queue before the next shift.": "下一班开始前先处理电话复核队列。",
  "No review queue right now.": "当前没有电话复核队列。",
  "Open follow-ups": "待跟进客户",
  "Review follow-ups while caller context is fresh.": "趁客户背景还清楚时处理跟进。",
  "No open lead follow-up work.": "暂无待处理线索跟进。",
  "Failed calls": "失败电话",
  "Review failed calls and the number callers dial.": "检查失败电话和客户拨打的号码。",
  "No failed calls in this business.": "这个业务暂无失败电话。",
  "Saved follow-ups": "已保存跟进",
  "Saved actions are visible to the team.": "团队可以看到已保存的行动。",
  "Follow-up actions will appear after call review.": "电话复核后，跟进行动会显示在这里。",
  "Conversion path": "转化路径",
  "How caller work moves from first contact to booked appointments and team follow-up.": "查看客户从来电到预约和团队跟进的流转。",
  "Calls handled": "已处理电话",
  "{completed} completed / {failed} failed": "{completed} 已完成 / {failed} 失败",
  "Lead signals": "线索信号",
  "{count} still need follow-up": "{count} 位仍需跟进",
  "Bookings created": "已创建预约",
  "{count} came from caller intent": "{count} 个来自客户意向",
  "Team touches": "团队跟进",
  "{count} notes and actions saved": "{count} 条备注和行动已保存",
  "Caller source mix": "客户来源构成",
  "Where calls and bookings are coming from.": "查看电话和预约来自哪里。",
  "{calls} calls / {leads} lead signals": "{calls} 通电话 / {leads} 个线索信号",
  "{rate} booking rate": "{rate} 预约率",
  "Website": "网站",
  "Team outreach": "团队外呼",
  "Inbound calls": "来电",
  "Daily operating trend": "每日运营趋势",
  "Calls, bookings, lead signals, and review work by day.": "按天查看电话、预约、线索和待处理工作。",
  "Day": "日期",
  "Sun": "周日",
  "Mon": "周一",
  "Tue": "周二",
  "Wed": "周三",
  "Thu": "周四",
  "Fri": "周五",
  "Sat": "周六",
  "Recent caller work": "最近客户工作",
  "The latest calls with the next useful team action.": "最近电话以及团队下一步可做的事。",
  "Recent caller work will appear once this business has calls.": "这个业务有电话后，最近客户工作会显示在这里。",
  "No caller work yet": "暂无客户工作",
  "Needs team review": "需要团队查看",
  "Operating clean": "运行正常",
  "Review queue: {count} call needs a human look": "复核队列：{count} 通电话需要人工查看",
  "Review queue: {count} calls need a human look": "复核队列：{count} 通电话需要人工查看",
  "Failed calls: {count} need a check on the number callers dial": "失败电话：{count} 通需要检查客户拨打的号码",
  "Open follow-ups: {count} caller still needs follow-up": "待跟进：{count} 位客户仍需跟进",
  "Open follow-ups: {count} callers still need follow-up": "待跟进：{count} 位客户仍需跟进",
  "No open review queue, failed calls, or lead follow-up gaps in this business.": "这个业务当前没有复核队列、失败电话或线索跟进缺口。",
  "Team report - {business}": "{business} 团队摘要",
  "Status: {status}": "状态：{status}",
  "Calls: {count}": "电话：{count}",
  "Completed calls: {count}": "已完成电话：{count}",
  "Failed calls: {count}": "失败电话：{count}",
  "Bookings: {count}": "预约：{count}",
  "Booking rate: {rate}": "预约率：{rate}",
  "Lead signals: {count}": "线索信号：{count}",
  "Open follow-ups: {count}": "待跟进客户：{count}",
  "Follow-up coverage: {coverage}": "跟进覆盖：{coverage}",
  "Team touches: {count}": "团队跟进：{count}",
  "Next actions:": "下一步行动：",
  "No immediate review items.": "当前没有需要立即处理的事项。",
  "Team report for {business}": "{business} 团队摘要",
  "business": "这个业务",
  "Cancelled": "已取消",
  "Completed": "已完成",
  "No-show": "未到场",
  "No follow-up yet": "暂无跟进",
  "Owner updated": "负责人已更新",
  "No follow-up": "无需跟进",
  "No outcome yet": "暂无处理结果",
  "No phone": "无电话",
  "Inbound booking flow": "先预约，团队确认",
  "Team-confirmed booking receptionist": "先预约，团队确认",
  "Qualified": "已确认意向",
  "No activity yet": "暂无活动",
  "Customer conversation activity will appear after a live call or receptionist test completes.": "完成真实电话或接待测试后，客户对话活动会显示在这里。",
  "Saved notes and next actions will appear here.": "保存的备注和下一步动作会显示在这里。",
  "Select a call to review the summary, transcript, and follow-up.": "选择一通电话查看摘要、记录和跟进。",
  "No call selected": "未选择电话",
  "All leads": "全部线索",
  "Review caller": "查看客户",
  "Review caller {caller}": "查看客户 {caller}",
  "Caller detail": "客户详情",
  "This caller could not be found in the current business.": "当前业务中找不到这位客户。",
  "{stage} caller · {source}": "{stage}客户 · {source}",
  "Review callers who may need follow-up, booking, or owner assignment.": "查看需要跟进、预约或分配负责人的客户。",
  "Search leads": "搜索线索",
  "Stage": "阶段",
  "All stages": "全部阶段",
  "Contacted": "已联系",
  "Booked": "已预约",
  "Closed": "已关闭",
  "Priority": "优先级",
  "All priorities": "全部优先级",
  "High priority": "高优先级",
  "Warm": "普通",
  "All owners": "全部负责人",
  "Assigned": "已分配",
  "Owned": "已分配",
  "{count} caller": "{count} 位客户",
  "{count} callers": "{count} 位客户",
  "No callers match that search.": "没有匹配的客户。",
  "No {stage} callers match the current filters.": "当前筛选下没有{stage}客户。",
  "No calls match this priority filter.": "没有匹配这个优先级的电话。",
  "No callers match this owner filter.": "没有匹配这个负责人的客户。",
  "No callers match this follow-up health queue.": "没有匹配这个跟进队列的客户。",
  "Calls that need follow-up will appear here.": "需要跟进的电话会显示在这里。",
  "Follow-up health": "跟进健康度",
  "Keep follow-up from going cold": "别让跟进冷掉",
  "Turn easy-to-miss callers into review queues before they wait too long for a human response.": "把容易漏掉的客户放进待处理队列，避免客户等太久。",
  "Assign": "分配",
  "Check": "检查",
  "Start": "开始",
  "Unassigned leads": "未分配线索",
  "Give every open caller a visible owner before the day ends.": "当天结束前，让每位待跟进客户都有清楚的负责人。",
  "Every open caller has a clear owner.": "每位待跟进客户都有清楚的负责人。",
  "High-priority open": "待处理高优先级",
  "High-priority callers still need a booking, call back, or close action.": "高优先级客户还需要预约、回拨或关闭处理。",
  "No high-priority callers are waiting in open stages.": "暂无停留在开放阶段的高优先级客户。",
  "These callers have no saved owner change, note, or follow-up action yet.": "这些客户还没有保存负责人变更、备注或跟进行动。",
  "Every active caller has a saved team touch.": "每位活跃客户都有已保存的团队跟进。",
  "Booking follow-through": "预约后续确认",
  "Booked callers should have a saved booking link or be confirmed from the detail panel.": "已预约客户应有已保存的预约记录，或从详情页确认。",
  "Booked callers have no visible follow-through gap.": "已预约客户没有明显的后续缺口。",
  "Follow-up queue": "跟进队列",
  "{count} high priority": "{count} 位高优先级",
  "No callers to review": "暂无客户需要查看",
  "Lead": "线索",
  "Created": "创建时间",
  "Source": "来源",
  "First seen": "首次出现",
  "Select a caller to review contact details and follow-up.": "选择一位客户查看联系方式和跟进。",
  "No caller selected": "未选择客户",
  "Caller context": "客户背景",
  "Save owner": "保存负责人",
  "Owner saved": "负责人已保存",
  "Follow-up history": "跟进历史",
  "Owner changes and follow-up actions will appear here.": "负责人变更和跟进行动会显示在这里。",
  "Follow-up action could not be saved. Try again.": "跟进行动未能保存。请重试。",
  "Enter an owner email before saving.": "保存前请输入负责人邮箱。",
  "Enter a valid owner email.": "请输入有效的负责人邮箱。",
  "Owner could not be saved. Try again.": "负责人未能保存。请重试。",
  "Confirm booking": "确认预约",
  "Call back": "回拨",
  "Mark contacted": "标记已联系",
  "Owner assigned": "已分配负责人",
  "Phone copied": "电话号码已复制",
  "Copy failed": "复制失败",
  "Copy {value}": "复制 {value}",
  "{country} phone number": "{country} 电话号码",
  "New Zealand": "新西兰",
  "Australia": "澳大利亚",
  "United States": "美国",
  "International": "国际",
  "Manage the number callers dial, connect another number if needed, and confirm callers reach the right receptionist.": "管理客户拨打的号码，需要时接入另一个号码，并确认来电会由正确的接待员接起。",
  "Buy or connect the number callers will dial, then confirm it reaches the right receptionist.": "购买或接入客户会拨打的号码，然后确认来电会由正确的接待员接起。",
  "Call setup": "来电设置",
  "Caller number is ready to test": "客户号码可以测试",
  "Choose the number callers will dial": "选择客户拨打的号码",
  "Keep the caller number and receptionist matched before taking real calls.": "接真实电话前，请确认客户号码和接待员匹配。",
  "Search available numbers or connect one already available for this business.": "搜索可用号码，或接入这个业务已有的号码。",
  "Test call": "拨打测试电话",
  "Configure receptionist": "配置接待员",
  "View calls": "查看电话",
  "Number is live for this business.": "这个业务的号码已可接听。",
  "Live caller number": "当前客户号码",
  "No number assigned": "尚未分配号码",
  "Incoming calls": "来电",
  "Choose receptionist": "选择接待员",
  "Test calls": "测试电话",
  "Ready from this number": "可从这个号码测试",
  "Needs receptionist": "需要接待员",
  "Caller number": "客户号码",
  "Customers can call this number.": "客户可以拨打这个号码。",
  "Choose the number customers will call first.": "先选择客户会拨打的号码。",
  "Incoming calls will reach the current receptionist.": "来电会由当前接待员接起。",
  "Choose the receptionist before opening this number to callers.": "把号码开放给客户前，请先选择接待员。",
  "Your team can place test calls from this business number.": "团队可以用这个业务号码发起测试电话。",
  "Choose the receptionist before placing test calls.": "发起测试电话前，请先选择接待员。",
  "Business numbers": "业务号码",
  "Numbers are attached to this business.": "号码已接入这个业务。",
  "Buy or connect a number to start.": "购买或接入号码后即可开始。",
  "{count} number": "{count} 个号码",
  "{count} numbers": "{count} 个号码",
  "Buy a new number": "购买新号码",
  "Search numbers available in this business country without leaving setup.": "在设置流程中直接搜索这个业务所在国家的可用号码。",
  "Search available phone numbers before choosing one for callers.": "先搜索可用电话号码，再选择客户会拨打的号码。",
  "Country": "国家",
  "Digits or city": "号码数字或城市",
  "Search": "搜索",
  "Searching": "正在搜索",
  "Number search unavailable": "暂时无法搜索号码",
  "{error}. Check account access and any required business details before buying new numbers.": "{error}。购买新号码前，请检查账号权限和必要的业务信息。",
  "Number search is unavailable": "暂时无法搜索号码",
  "Number search failed.": "号码搜索失败。",
  "Number purchase failed.": "号码购买失败。",
  "Could not connect that number.": "暂时无法接入这个号码。",
  "Phone number setup is not ready yet.": "电话号码设置暂时还未就绪。",
  "phone service": "电话服务",
  "account access": "账号权限",
  "Voice ready": "可接电话",
  "Limited": "受限",
  "Usage charges apply after purchase.": "购买后会产生使用费用。",
  "Buy number": "购买号码",
  "No matching numbers were found. Try another city or digit sequence.": "没有找到匹配号码。可以换一个城市或号码数字再试。",
  "No matching numbers were found. Try another country, city, or digit sequence.": "没有找到匹配号码。可以换一个国家、城市或号码数字再试。",
  "Search available numbers if you do not already have one.": "如果还没有可用号码，可以先搜索可购买号码。",
  "Search available numbers before buying. Only numbers that can be purchased are shown.": "购买前先搜索可用号码。这里只显示可以购买的号码。",
  "No matching numbers": "没有匹配号码",
  "Find available numbers": "查找可用号码",
  "Connect another number": "接入另一个号码",
  "Connect an existing number": "接入已有号码",
  "Use this when the business already has a number available for callers.": "如果这个业务已经有客户可拨打的号码，请用这里接入。",
  "Search or paste a number": "搜索或粘贴号码",
  "Paste a different number already available for this business.": "粘贴这个业务已有的另一个号码。",
  "Use a number already available for this business.": "使用这个业务已有的号码。",
  "Phone number": "电话号码",
  "Paste phone number": "粘贴电话号码",
  "This number is already live for this business.": "这个号码已经是当前业务的上线号码。",
  "Include the country code.": "请包含国家区号。",
  "After connecting, incoming calls use the current receptionist and test calls can start from this business number.": "接入后，来电会由当前接待员接起，测试电话也可以从这个业务号码发起。",
  "Numbers attached to this business and whether callers can reach the receptionist.": "查看这个业务已接入的号码，以及客户是否能由接待员接起。",
  "Buy or connect a number to make this business reachable by phone.": "购买或接入号码后，客户才能通过电话联系这个业务。",
  "No numbers connected": "尚未接入号码",
  "Number": "号码",
  "Attached": "已连接",
  "{count} booking": "{count} 个预约",
  "{count} bookings": "{count} 个预约",
  "{count} active phone number": "{count} 个已启用号码",
  "{count} active phone numbers": "{count} 个已启用号码",
  "Add an owner before billing starts.": "开始计费前，请先添加业务负责人。",
  "Connect a caller-facing number.": "请先连接客户会拨打的号码。",
  "Activity will appear after the first call or booking.": "第一通电话或预约后，用量会显示在这里。",
  "{item}: {detail}": "{item}：{detail}",
  "Failed calls: {count} in {period}": "失败电话：{period} 有 {count} 通",
  "Collect payment details and start the paid plan.": "可以收集付款信息，并开始付费方案。",
  "Review the business before collecting payment details.": "收集付款信息前，请先检查这个业务。",
  "Payment review - {business}": "{business} 付款复核",
  "Period: {period}": "周期：{period}",
  "Billing contact: {contact}": "账单联系人：{contact}",
  "Phone numbers: {count}": "电话号码：{count}",
  "Calls this month: {used}/{included}": "本月电话：{used}/{included}",
  "Bookings this month: {used}/{included}": "本月预约：{used}/{included}",
  "Readiness: {ready}/{total}": "准备度：{ready}/{total}",
  "Open items:": "待处理项目：",
  "None": "无",
  "Please review payment readiness for this business.": "请检查这个业务的付款准备状态。",
  "Billing for {business}": "{business} 账单",
  "{calls} and {bookings} in {period}.": "{period}：{calls}，{bookings}。",
  "Caller-facing numbers are active.": "客户来电号码已启用。",
  "Connect a number before paid launch.": "付费上线前请先连接号码。",
  "Review failed calls before payment starts.": "开始收款前请先检查失败电话。",
  "No failed calls in this billing period.": "这个账单周期没有失败电话。",
  "Billing review goes to {contact}.": "账单检查会发送给 {contact}。",
  "Add a business owner or billing contact.": "请添加业务负责人或账单联系人。",
  "Review plan usage, owner details, phone setup, and payment readiness before moving this business to paid.": "转为付费前，检查方案用量、负责人信息、电话设置和付款准备状态。",
  "Payment readiness": "付款准备",
  "Know when a trial is ready for paid launch": "判断试用是否可以进入付费",
  "Check usage, billing contact, caller numbers, and unresolved failed calls before moving a business onto a paid plan.": "转为付费方案前，确认用量、账单联系人、来电号码和未处理失败电话。",
  "Numbers": "号码",
  "{count} left": "剩余 {count}",
  "allowance reached": "已达到额度",
  "active numbers": "已启用号码",
  "Track": "跟踪",
  "Connect": "连接",
  "Missing": "缺失",
  "Business owner": "业务负责人",
  "Usage tracking": "用量跟踪",
  "Caller numbers": "来电号码",
  "Billing contact": "账单联系人",
  "Current month activity is visible.": "本月活动已可查看。",
  "Ready for paid launch": "可以进入付费",
  "Review before paid launch": "付费前需检查",
  "Trial review": "试用复核",
  "Usage is tracked now. Payment details are collected when this business is ready to leave trial.": "当前已开始跟踪用量。业务准备结束试用时再收集付款信息。",
  "Trial active": "试用中",
  "Current plan": "当前方案",
  "Private trial": "私享试用方案",
  "Included this month: {calls} calls and {bookings} bookings while the account is being prepared for paid launch.": "账户准备进入付费前，本月包含 {calls} 通电话和 {bookings} 个预约。",
  "Phone numbers": "电话号码",
  "Payment review summary": "付款复核摘要",
  "Copy summary": "复制摘要",
  "Send review": "发送复核",
  "Copy failed. The review message still includes the current payment summary.": "复制失败。复核信息仍包含当前付款摘要。",
  "Period": "周期",
  "Open items": "待处理项目",
  "Usage snapshot": "用量快照",
  "Real business activity for {period}.": "{period} 的真实业务活动。",
  "Calls this month": "本月电话",
  "Bookings this month": "本月预约",
  "Payment launch checklist": "付费前检查",
  "Confirm these before payment collection starts.": "开始收款前确认这些项目。",
  "Invoice history": "发票记录",
  "Invoices will appear here after the trial converts to a paid plan.": "试用转为付费后，发票会显示在这里。",
  "This business is still in trial, so there are no invoice documents yet.": "这个业务仍在试用中，因此还没有发票文件。",
  "No invoices yet": "暂无发票",

  "Calls for {business} will be answered by \"{receptionist}\".": "{business} 的客户电话会由「{receptionist}」接听。",
  "the current receptionist setup": "当前接待设置",
  "Select a business before testing or placing calls.": "测试或拨打电话前，请先选择业务。",
  "Ready to call": "可以拨打",
  "Finish call readiness": "完成接听准备",
  "Launch checks": "接听准备",
  "Phone": "电话",
  "Reception style": "接待方式",
  "Ready to answer": "可以接听",
  "Finish phone setup": "完成电话设置",
  "Finish receptionist": "完成接待员设置",
  "Alerts": "提醒",
  "Try a caller question before customers hear it.": "先试一个客户问题，再让真实客户听到。",
  "Start test call": "开始测试",
  "Call the customer": "拨打客户电话",
  "Enter the customer number and review before dialing.": "输入客户号码，检查后再拨打。",
  "Name": "姓名",
  "Optional": "可选",
  "Review and call": "检查后拨打",
  "Starting...": "正在开始...",
  "Call this customer now?": "现在拨打这位客户吗？",
  "This will dial the customer from {number}.": "将使用 {number} 拨打客户电话。",
  "the active number": "当前号码",
  "From": "从",
  "To": "至",
  "Not provided": "未填写",
  "Cancel": "取消",
  "Call customer": "拨打客户",
  "Current receptionist": "当前接待员",
  "Testing \"{receptionist}\" for {business}.": "正在为 {business} 测试「{receptionist}」。",
  "Test call status": "测试电话",
  "End test": "结束测试",
  "Type what the caller would ask": "输入客户可能会问的问题",
  "Send": "发送",
  "Ready to start": "可以开始",
  "Needs retry": "需要重试",
  "Open a test call to try the receptionist before customers hear it.": "打开测试电话，先试试接待员再让客户听到。",
  "Test call is ready.": "测试电话已准备好。",
  "Action completed.": "操作已完成。",
  "Action completed: {summary}": "操作已完成：{summary}",
  "Action could not be completed. Try again or adjust the caller request.": "操作未完成。请重试，或调整客户问题。",
  "The test call stopped unexpectedly. Try again.": "测试电话意外中断，请重试。",
  "Could not confirm your access. Try again in a moment.": "暂时无法确认访问权限，请稍后重试。",
  "The test call sent an unreadable update. Try again.": "测试电话返回了一条无法读取的更新，请重试。",
  "Test call could not connect.": "测试电话无法连接。",
  "Enter the customer phone number before starting a live call.": "开始真实通话前，请先输入客户电话号码。",
  "Use international format, for example {phone}.": "请使用国际格式，例如 {phone}。",
  "Enter a customer number. This is the active business phone number.": "请输入客户号码。当前填写的是业务接听号码。",
  "This number was marked as do-not-call. Do not start a live call.": "这个号码已标记为不再联系，请不要发起真实通话。",
  "This number was marked as wrong number. Check the contact before calling.": "这个号码已标记为错误号码，请先核对联系人。",
  "Select a business before starting a live call.": "开始真实通话前，请先选择业务。",
  "Finish {item} first: {detail}.": "请先完成{item}：{detail}。",
  "Connecting to {business}...": "正在连接到 {business}...",
  "Call queued. It should start shortly.": "通话已排队，应该很快开始。",
  "Call request sent. Check recent calls for updates.": "通话请求已发送，请在最近电话中查看更新。",
  "Call could not be started. Check the number and try again.": "通话无法开始，请检查号码后重试。",
  "Active phone number": "当前电话号码",

  "All integrations": "全部集成",
  "{name} integration": "{name} 集成",
  "Connect calendars, staff alerts, website forms, and business system updates.": "连接日历、团队提醒、网站表单和业务系统更新。",
  "Connected tools": "已连接工具",
  "Review calendars, alerts, website forms, and update destinations for this business.": "查看这个业务的日历、提醒、网站表单和更新去向。",
  "{ready}/{total} ready": "{ready}/{total} 已就绪",
  "{ready}/{total} clear": "{ready}/{total} 正常",
  "{ready}/3 ready": "{ready}/3 已就绪",
  "Manage calendar": "管理日历",
  "Calendar sharing": "日历共享",
  "Google Calendar, Apple Calendar, and Outlook links are available.": "Google 日历、Apple 日历和 Outlook 链接已可用。",
  "Calendar sharing is waiting for setup.": "日历共享仍需设置。",
  "Manage website": "管理网站",
  "Website sync": "网站同步",
  "{count} website page imported for review.": "已导入 {count} 个网站页面待查看。",
  "{count} website pages imported for review.": "已导入 {count} 个网站页面待查看。",
  "Website saved on the profile; import approved pages into Answers.": "业务资料里已保存网站，可把已批准页面导入答案。",
  "Add a website and import approved pages into Answers.": "添加网站，并把已批准页面导入答案。",
  "Imported": "已导入",
  "Ready to import": "可导入",
  "Manage alerts": "管理提醒",
  "Staff alerts": "团队提醒",
  "Slack, Telegram, or email can receive selected alert types.": "Slack、Telegram 或邮箱可以接收所选提醒。",
  "Choose where call and booking alerts should go.": "选择电话和预约提醒发送到哪里。",
  "Manage notifications": "管理通知",
  "Send call outcomes and step-in requests to the staff channel.": "把电话结果和人工介入请求发送到团队频道。",
  "Send urgent alerts to an operations chat.": "把紧急提醒发送到运营聊天。",
  "Send booking and call summaries to the selected recipients.": "把预约和电话摘要发送给所选收件人。",
  "Recipients can be saved now; email sending needs setup before alerts go out.": "现在可以保存收件人；发送邮件前仍需完成邮箱设置。",
  "Email setup": "邮箱设置",
  "Manage updates": "管理更新",
  "Business system updates": "业务系统更新",
  "Update destinations": "更新去向",
  "{count} destination receiving booking and call updates.": "{count} 个去向正在接收预约和电话更新。",
  "{count} destinations receiving booking and call updates.": "{count} 个去向正在接收预约和电话更新。",
  "Send booking and call updates to another business system.": "把预约和电话更新发送到另一个业务系统。",
  "Send booking and call updates to another tool your team uses.": "把预约和电话更新发送到团队正在使用的其他工具。",
  "{count} destination": "{count} 个去向",
  "{count} destinations": "{count} 个去向",
  "Ready destinations": "已就绪去向",
  "At least one staff alert destination can receive updates.": "至少一个团队提醒去向可以接收更新。",
  "Add Slack, Telegram, or email before relying on alerts.": "先添加 Slack、Telegram 或邮箱，再依赖提醒。",
  "Choose": "选择",
  "Selected alerts": "已选提醒",
  "{count} alert type selected for staff.": "已为团队选择 {count} 类提醒。",
  "{count} alert types selected for staff.": "已为团队选择 {count} 类提醒。",
  "Choose the call and booking events staff should receive.": "选择团队需要接收的电话和预约提醒。",
  "Clear": "正常",
  "Delivery issues": "发送问题",
  "No alert delivery issues in recent history.": "最近没有提醒发送问题。",
  "Email sending is configured for selected recipients.": "所选收件人的邮箱发送已配置。",
  "Recipients are saved, but email sending needs setup before alerts go out.": "收件人已保存，但发送提醒前仍需完成邮箱设置。",
  "Email is optional when Slack or Telegram is ready.": "Slack 或 Telegram 就绪时，邮箱可选。",
  "Email service": "邮箱发送",
  "Choose a business before creating a website connection.": "请先选择业务，再创建网站连接。",
  "Add a short name for this connection.": "请为这个连接添加一个简短名称。",
  "Website connection could not be created.": "暂时无法创建网站连接。",
  "Choose a business before creating an update destination.": "请先选择业务，再创建更新去向。",
  "Add where updates should be sent.": "请添加更新要发送到哪里。",
  "Choose at least one update type.": "请至少选择一种更新类型。",
  "Update destination could not be created.": "暂时无法创建更新去向。",
  "Sign in again before saving this connection.": "请重新登录后保存这个连接。",
  "Use a public secure link for this connection.": "请使用公开、安全的连接链接。",
  "This connection could not be saved. Check the details and try again.": "暂时无法保存这个连接。请检查内容后重试。",
  "Open Answers": "打开答案",
  "Import approved website pages into Answers so the receptionist can use them on calls.": "把已批准的网站页面导入答案，接待员通话时即可使用。",
  "Business website": "业务网站",
  "Not set": "未设置",
  "Imported pages": "已导入页面",
  "Add website first": "先添加网站",
  "Add a website to the business profile, then import approved pages from Answers.": "先在业务资料里添加网站，然后从答案导入已批准页面。",
  "No website pages imported": "尚未导入网站页面",
  "Staff alert health": "团队提醒状态",
  "Know whether staff alerts can go live": "确认团队提醒是否可以上线",
  "Confirm alert destinations, selected events, delivery failures, and email readiness before callers rely on staff follow-up.": "在客户依赖团队跟进前，确认提醒去向、提醒类型、发送问题和邮箱状态。",
  "Staff notifications": "团队通知",
  "Choose where call outcomes, follow-ups, booking changes, and step-in requests should go.": "选择电话结果、跟进、预约变化和人工介入请求要发送到哪里。",
  "Manage this alert destination and the event types it should receive.": "管理这个提醒去向，以及它需要接收的提醒类型。",
  "Save notifications": "保存通知",
  "Saved": "已保存",
  "Slack alert link": "Slack 提醒链接",
  "Slack alert destination": "Slack 提醒去向",
  "Paste Slack alert link": "粘贴 Slack 提醒链接",
  "Paste Slack alert destination": "粘贴 Slack 提醒去向",
  "Telegram connection key": "Telegram 连接密钥",
  "Telegram setup code": "Telegram 设置代码",
  "Connection key saved": "连接密钥已保存",
  "Setup code saved": "设置代码已保存",
  "Paste Telegram connection key": "粘贴 Telegram 连接密钥",
  "Paste Telegram setup code": "粘贴 Telegram 设置代码",
  "Telegram chat code": "Telegram 聊天代码",
  "Telegram chat destination": "Telegram 聊天去向",
  "Chat code": "聊天代码",
  "Chat destination": "聊天去向",
  "Email recipients": "邮箱收件人",
  "Email recipients are saved, but email sending needs setup before alerts go out.": "邮箱收件人已保存，但发送提醒前仍需完成邮箱设置。",
  "Alert types": "提醒类型",
  "Send the summary after a call ends.": "通话结束后发送摘要。",
  "Alert staff when a caller needs recovery.": "客户需要补救跟进时提醒团队。",
  "Notify the owner when a caller needs follow-up.": "客户需要跟进时通知负责人。",
  "Send confirmed booking details.": "发送已确认的预约详情。",
  "Tell staff when a booking is cancelled.": "预约取消时通知团队。",
  "Send urgent or sensitive calls to staff.": "把紧急或敏感来电发送给团队。",
  "Could not save notification settings.": "暂时无法保存通知设置。",
  "Alert history": "提醒记录",
  "Recent Slack, Telegram, and email alerts for this business.": "这个业务最近的 Slack、Telegram 和邮箱提醒。",
  "New alerts will appear after calls or bookings trigger an enabled event.": "电话或预约触发已启用的提醒后，新提醒会显示在这里。",
  "No alert history yet": "暂无提醒记录",
  "Channel": "渠道",
  "Alert": "提醒",
  "Detail": "详情",
  "Delivered": "已送达",
  "delivered": "已送达",
  "skipped": "已跳过",
  "{channel} accepted the alert.": "{channel} 已接收提醒。",
  "{channel} needs setup before this alert can be sent.": "{channel} 需要先完成设置，才能发送这类提醒。",
  "{channel} could not accept the alert. Review the connection before the next call.": "{channel} 未能接收提醒。下一通电话前请检查连接。",
  "Email sending needs setup before this alert can be sent.": "邮箱发送需要先完成设置，才能发送这类提醒。",
  "Slack setup needs review before this alert can be sent.": "Slack 设置需要检查，之后才能发送这类提醒。",
  "Telegram setup needs review before this alert can be sent.": "Telegram 设置需要检查，之后才能发送这类提醒。",
  "{channel} alert failed. Review the integration before the next call.": "{channel} 提醒发送失败。下一通电话前请检查集成。",
  "Manage website connection": "管理网站连接",
  "Manage website forms": "管理网站表单",
  "Website booking connection": "网站预约连接",
  "Website booking form": "网站预约表单",
  "{count} website connection can send booking requests.": "{count} 个网站连接可以发送预约请求。",
  "{count} website connections can send booking requests.": "{count} 个网站连接可以发送预约请求。",
  "Connect website forms and booking tools to this business.": "把网站表单和预约工具连接到这个业务。",
  "{count} website connection": "{count} 个网站连接",
  "{count} website connections": "{count} 个网站连接",
  "Let your website send booking requests into Attenda.": "让你的网站把预约请求发送到 Attenda。",
  "Connection name": "连接名称",
  "Setup name": "设置名称",
  "Creating...": "正在创建...",
  "Create connection": "创建连接",
  "Create setup": "创建设置",
  "Connection code ready": "连接码已准备好",
  "Website setup ready": "网站设置已准备好",
  "Copy it into the website form now. The full code is hidden after you leave this page.": "现在复制到网站表单中。离开此页面后，完整代码会被隐藏。",
  "Give this to the person updating your website. It is hidden after you leave this page.": "把这段内容交给更新网站的人。离开此页面后它会被隐藏。",
  "Copied": "已复制",
  "Retry copy": "重试复制",
  "Copy connection code": "复制连接码",
  "Copy setup code": "复制设置代码",
  "Copy failed. Try again before leaving this page.": "复制失败。离开此页面前请重试。",
  "Create a connection when a website form should send booking requests to this business.": "当网站表单需要把预约请求发送到这个业务时，再创建连接。",
  "Create a setup item when a website form should send booking requests to this business.": "当网站表单需要把预约请求发送到这个业务时，创建一项设置。",
  "No website connection yet": "暂无网站连接",
  "No website form setup yet": "暂无网站表单设置",
  "Setup code ending {value}": "设置码尾号 {value}",
  "Saved setup ending {value}": "已保存设置尾号 {value}",
  "Used": "已使用",
  "New": "新建",
  "Created {time}": "创建于 {time}",
  "Where to send updates": "更新发送到哪里",
  "Paste update destination link": "粘贴更新接收链接",
  "Paste secure destination link": "粘贴安全接收链接",
  "Create destination": "创建去向",
  "Update types": "更新类型",
  "Security code ready": "安全代码已准备好",
  "Update setup ready": "更新设置已准备好",
  "Copy it into the update destination now. The full code is hidden after you leave this page.": "现在复制到更新接收位置。离开此页面后，完整代码会被隐藏。",
  "Give this setup code to the person managing that destination. It is hidden after you leave this page.": "把这段设置代码交给管理该去向的人。离开此页面后它会被隐藏。",
  "Copy security code": "复制安全代码",
  "Create a destination when another system should receive booking or call updates.": "当其他系统需要接收预约或电话更新时，创建一个去向。",
  "No update destinations yet": "暂无更新去向",
  "Saved destination": "已保存去向",
  "Saved update destination": "已保存更新去向",
  "Last send: {status}": "上次发送：{status}",
};

export function joinClassNames(...values: Array<string | false | undefined>) {
  return values.filter(Boolean).join(" ");
}

function normalizeLocale(value: string | null | undefined): Locale | null {
  const normalized = value?.toLowerCase();
  if (!normalized) return null;
  if (normalized === "zh" || normalized.startsWith("zh-") || normalized === "cn" || normalized === "chinese") return "zh";
  if (normalized === "en" || normalized.startsWith("en-") || normalized === "english") return "en";
  return null;
}

export function resolveInitialLocale(): Locale {
  if (typeof window === "undefined") return "en";

  const searchLocale = normalizeLocale(new URLSearchParams(window.location.search).get("lang"));
  if (searchLocale) return searchLocale;

  const storedLocale = normalizeLocale(window.localStorage.getItem(localeStorageKey));
  if (storedLocale) return storedLocale;

  const browserLocale = normalizeLocale(window.navigator.language);
  return browserLocale ?? "en";
}

export function interpolate(message: string, params?: TranslationParams) {
  if (!params) return message;

  return message.replace(/\{([a-zA-Z0-9_]+)\}/gu, (match, key) => {
    const value = params[key];
    return value === undefined ? match : String(value);
  });
}

export function localeToIntlLocale(locale: Locale) {
  return locale === "zh" ? "zh-CN" : "en-US";
}

export function getStoredLocale(): Locale {
  if (typeof window === "undefined") return "en";
  return normalizeLocale(window.localStorage.getItem(localeStorageKey)) ?? normalizeLocale(document.documentElement.lang) ?? "en";
}

export function getStoredIntlLocale() {
  return localeToIntlLocale(getStoredLocale());
}

export function translateMessage(locale: Locale, key: string, params?: TranslationParams) {
  const template = locale === "zh" ? zhMessages[key] ?? key : key;
  return interpolate(template, params);
}
